"use strict";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-small);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-regular);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-large);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--icon-size-x-large);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  /* Anti-aliasing icons cross-browsers */\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-small);\n  line-height: var(--line-height-large);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n  letter-spacing: var(--letter-spacing-regular);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-medium);\n  line-height: var(--line-height-small);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-x-x-large);\n  line-height: var(--line-height-x-small);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-bold);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-semibold);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: var(--font-weight-regular);\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  letter-spacing: var(--letter-spacing-dense);\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  letter-spacing: var(--letter-spacing-spacious);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  font-family: var(--font-family-mono);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  color: var(--foreground-primary);\n  font-size: var(--font-size-x-large);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-x-small);\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  color: var(--foreground-primary);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-small);\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  gap: 0;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-small, 4px);\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-small, 8px);\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-regular, 16px);\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-large, 24px);\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-large, 32px);\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-x-large, 48px);\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-x-x-large, 64px);\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-large, 24px);\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: var(--spacing-regular);\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-pink-50, #fff7fb);\n  border-color: var(--color-pink-600, #dd2270);\n\n  > ",
        " {\n    color: var(--color-pink-600, #dd2270);\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-yellow-50, #fffae6);\n  border-color: var(--color-yellow-600, #a66300);\n\n  > ",
        " {\n    color: var(--color-yellow-600, #a66300);\n  }\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-blue-50, #f5faff);\n  border-color: var(--color-blue-600, #0072d6);\n\n  > ",
        " {\n    color: var(--color-blue-600, #0072d6);\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-green-50, #f2fcfc);\n  border-color: var(--color-green-600, #108484);\n\n  > ",
        " {\n    color: var(--color-green-600, #108484);\n  }\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: row;\n\n  @media all and (max-width: 744px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  background: none;\n  border-radius: var(--border-radius-small, 6px);\n  border: none;\n  color: var(--color-neutral-700, #425678);\n  cursor: pointer;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  transition: ease-in-out color;\n  width: 24px;\n  margin-left: var(--spacing-regular, 16px);\n\n  :hover {\n    color: var(--color-neutral-800, #1f2f4f);\n  }\n\n  :focus {\n    outline: 2px solid var(--color-neutral-800, #1f2f4f);\n    outline-offset: -2px;\n  }\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: flex-start;\n  flex: 1 0 auto;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-800, #1f2f4f);\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  gap: var(--spacing-regular, 16px);\n  min-width: 0;\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  background-color: var(--color-neutral-50, #f7faff);\n  border-color: var(--color-neutral-500, #8492ae);\n  border-radius: var(--border-radius-small, 6px);\n  border-style: solid;\n  border-width: var(--border-width-small, 2px);\n  color: var(--color-neutral-700, #425678);\n  display: flex;\n  padding: var(--spacing-regular, 16px);\n\n  ",
        "\n\n  > ",
        " {\n    color: var(--color-neutral-700, #425678);\n    padding-top: var(--spacing-x-small);\n    padding-right: var(--spacing-small);\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 24px;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: var(--",
        ");\n    border: 1px solid var(--",
        ");\n  "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  height: 24px;\n  width: fit-content;\n  border-radius: var(--border-radius-small);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-x-small);\n  padding-left: var(--spacing-small);\n  padding-right: var(--spacing-small);\n\n  color: var(--color-neutral-800);\n  ",
        "\n\n  ",
        " {\n    max-width: 132px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  animation: spinner 0.6s linear infinite;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: center;\n  align-items: center;\n  padding: none;\n  width: 42px;\n  height: 42px;\n  > ",
        " {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  --padding-vertical: calc(var(--spacing-small) + 1px);\n  --padding-horizontal: calc(var(--spacing-regular) + 1px);\n  transition: box-shadow 0.5s;\n  padding: var(--padding-vertical) var(--padding-horizontal);\n  border-width: 0;\n  background: var(--background-button-primary-default);\n  color: var(--foreground-button-primary-default);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--background-button-primary-hover);\n    color: var(--foreground-button-primary-hover);\n  }\n\n  :active:not([disabled]) {\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    background: var(--background-button-primary-disabled);\n    border-color: transparent;\n  }\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border-color: var(--border-button-secondary-default);\n  color: var(--foreground-button-secondary-default);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--background-button-secondary-hover);\n    color: var(--foreground-button-secondary-hover);\n  }\n\n  :active:not([disabled]) {\n    background: var(--background-button-secondary-active);\n    color: var(--foreground-button-secondary-active);\n  }\n\n  &[disabled] {\n    color: var(--foreground-button-secondary-disabled);\n    border-color: var(--border-button-secondary-disabled);\n    background: transparent;\n    svg {\n      color: var(--foreground-button-secondary-disabled);\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border-color: none;\n  color: var(--foreground-button-tertiary-default);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--background-button-tertiary-hover);\n    color: var(--foreground-button-tertiary-hover);\n  }\n\n  :active:not([disabled]) {\n    background: var(--background-button-tertiary-active);\n    color: var(--foreground-button-tertiary-active);\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    color: var(--foreground-button-tertiary-disabled);\n    border-color: none;\n    background: transparent;\n    svg {\n      color: var(--foreground-button-secondary-disabled);\n    }\n  }\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--background-button-destructive-default);\n  border-color: none;\n  color: var(--foreground-button-destructive-default);\n\n  :hover:not(:active):not([disabled]) {\n    background: var(--background-button-destructive-hover);\n  }\n\n  :active:not([disabled]) {\n    border-color: transparent;\n  }\n\n  &[disabled] {\n    background: var(--background-button-destructive-disabled);\n    border-color: none;\n  }\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  color: transparent;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 40px;\n  border-width: var(--border-width-x-small);\n  border-color: transparent;\n  border-style: solid;\n  padding: var(--spacing-small) var(--spacing-regular);\n  position: relative;\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-regular);\n  border-radius: var(--border-radius-small);\n  letter-spacing: var(--letter-spacing-regular);\n  line-height: var(--line-height-regular);\n  cursor: pointer;\n  display: inline-flex;\n  gap: var(--spacing-small);\n  justify-content: center;\n  align-items: center;\n  transition: background 0.3s ease, box-shadow 0.5s ease;\n  outline-offset: 4px;\n  outline-color: var(--border-button-focus);\n\n  &[disabled] {\n    cursor: not-allowed;\n  }\n\n  :active:not([disabled]) {\n    box-shadow: rgb(189 199 219) 0px 1px 4px, rgb(189 199 219) 0px 0px 0px 3px;\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "  \n  ",
        "  \n  &[disabled] {\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-weight-bold);\n  letter-spacing: var(--letter-spacing-regular);\n  line-height: var(--line-height-regular);\n  color: var(--foreground-primary);\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  background-color: transparent;\n  outline: none;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n  color: var(--foreground-primary);\n  width: 100%;\n  padding: 0;\n  ::placeholder {\n    font-style: italic;\n    color: var(--foreground-input-placeholder);\n  }\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-left: var(--spacing-small);\n"
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-right: var(--spacing-small);\n"
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-disabled);\n  border: var(--border-width-x-small) solid var(--border-input-disabled);\n  background: var(--background-input-disabled);\n  outline: none;\n  cursor: not-allowed;\n\n  ",
        ",\n  ",
        ",\n  ",
        " {\n    background: var(--background-input-disabled);\n    color: var(--foreground-disabled);\n    cursor: not-allowed;\n    ::placeholder {\n      color: var(--foreground-disabled);\n    }\n  }\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--border-input-disabled);\n  }\n"
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n  border: var(--border-width-x-small) solid var(--border-input-error);\n\n  &:hover {\n    border: var(--border-width-x-small) solid var(--border-input-error);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--border-input-error-outline);\n    border: var(--border-width-x-small) solid var(--border-input-error);\n  }\n"
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--background-input-default);\n  border: var(--border-width-x-small) solid var(--border-input-readOnly);\n  outline: none;\n"
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0;\n  outline-color: var(--border-input-active);\n"
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-secondary);\n  padding-right: var(--spacing-small);\n"
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ",",
        ",",
        " {\n    font-size: var(--font-size-small);\n  }\n\n  ",
        " {\n    font-size: var(--icon-size-small);\n  }\n"
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  min-height: 42px;\n  background-color: var(--background-input-default);\n  border: var(--border-width-x-small) solid var(--border-input-default);\n  border-radius: var(--border-radius-small);\n  padding: var(--spacing-small) var(--spacing-regular);\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--border-input-hover);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--border-input-active-outline);\n    border: var(--border-width-x-small) solid var(--border-input-active);\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 0 0 var(--spacing-regular);\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-secondary);\n  margin-left: var(--spacing-regular);\n"
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-secondary);\n  margin-left: var(--spacing-regular);\n"
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: var(--foreground-primary);\n  cursor: default;\n  display: flex;\n  gap: var(--spacing-small);\n  line-height: var(--line-height-regular);\n\n  > ",
        " {\n    color: var(--foreground-secondary);\n    min-width: 18px;\n  }\n\n  /* Currently selected item */\n  &[data-state='checked'] {\n    color: var(--foreground-selected);\n    font-weight: var(--font-weight-bold);\n\n    > ",
        " {\n      color: var(--foreground-selected);\n    }\n  }\n"
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  background-color: var(--background-level-1);\n  border: var(--border-width-x-small) solid var(--border-input-default);\n  border-radius: var(--border-radius-small);\n  display: flex;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  min-height: 42px;\n  padding: var(--spacing-small) var(--spacing-regular);\n  padding-left: calc(var(--spacing-regular) - 1px);\n  ",
        "\n  ",
        "\n\n  & span:first-child {\n    flex: 1;\n    text-align: left;\n  }\n\n  ",
        " {\n    float: right;\n    font-size: ",
        ";\n  }\n\n  /* Placeholder text */\n  &[data-placeholder] {\n    color: var(--foreground-input-placeholder);\n    font-size: ",
        ";\n    font-style: italic;\n  }\n\n  /* Disabled state */\n  &[data-disabled] {\n    background-color: var(--background-input-disabled);\n    border-color: var(--border-input-disabled);\n    cursor: not-allowed;\n\n    ",
        ",\n    ",
        ",\n    ",
        " ",
        ",\n    &[data-placeholder] {\n      color: var(--foreground-disabled);\n    }\n  }\n\n  /* Hover state */\n  &:hover:not([data-disabled]) {\n    border-color: var(--border-input-hover);\n  }\n\n  &:focus-visible {\n    border-color: var(--border-input-active);\n    outline: var(--border-width-small) solid var(--border-input-active-outline);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--background-level-3);\n  border-radius: var(--border-radius-small);\n  box-shadow: var(--elevation-300);\n  font-size: ",
        ";\n  gap: var(--spacing-x-small);\n  padding: var(--spacing-small) 0;\n\n  ",
        "\n\n  ",
        " ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-x-small);\n"
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: var(--border-radius-small);\n  padding: var(--spacing-small) var(--spacing-regular);\n\n  /* Hover state */\n  &:hover,\n  &[data-highlighted] {\n    background-color: var(--background-selected);\n  }\n\n  &:focus-visible {\n    --padding-vertical: calc(var(--spacing-small) - 2px);\n    --padding-horizontal: calc(var(--spacing-regular) - 2px);\n\n    border: var(--border-width-small) solid var(--color-blue-600);\n    padding: var(--padding-vertical) var(--padding-horizontal);\n    outline: none;\n  }\n"
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: default;\n  color: var(--foreground-secondary);\n  font-size: var(--font-size-small);\n"
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n  &[data-disabled] {\n    pointer-events: none;\n\n    ",
        ", ",
        " {\n      color: var(--foreground-disabled);\n    }\n  }\n"
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: var(--foreground-secondary);\n  cursor: default;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  background: var(--background-level-2);\n  box-shadow: var(--elevation-300);\n\n  table {\n    border-collapse: collapse;\n  }\n\n  table thead tr th {\n    border-bottom: 1px solid var(--border-default);\n    padding-bottom: 8px;\n    background: var(--background-app);\n    color: var(--foreground-tertiary);\n    font-size: var(--font-size-small);\n    line-height: 24px;\n    text-transform: uppercase;\n  }\n\n  table tbody tr:first-child td {\n    padding-top: 8px;\n  }\n\n  // Work around to add spacing to table body to match figma\n  table thead.rdp-head {\n    border-left: 20px solid var(--background-app);\n    border-right: 20px solid var(--background-app);\n    position: relative;\n  }\n\n  table thead.rdp-head::before,\n  table thead.rdp-head::after {\n    content: '';\n    width: 20px;\n    border-bottom: 1px solid var(--border-default);\n    bottom: 0px;\n    position: absolute;\n    color: transparent;\n  }\n\n  table thead.rdp-head::before {\n    left: -30px;\n  }\n\n  table thead.rdp-head::after {\n    right: -30px;\n  }\n\n  table tbody.rdp-tbody {\n    border: 20px solid transparent;\n    border-top: none;\n  }\n"
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  background: var(--background-app);\n  padding: 16px 0 8px;\n"
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _taggedTemplateLiteral([
        "\n  width: 44px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  color: var(--foreground-primary);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  border-radius: 6px;\n\n  :hover {\n    background: var(--background-boolean-hover);\n  }\n\n  &:focus-visible {\n    outline-offset: 1px;\n    outline-color: var(--border-link-focus);\n    outline-width: var(--border-width-small);\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  &:disabled {\n    background: var(--background-input-disabled);\n    color: var(--foreground-disabled);\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 4px;\n  min-height: 4px;\n  border-radius: 100px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _taggedTemplateLiteral([
        "\n  width: 106px;\n"
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _taggedTemplateLiteral([
        "\n  width: 98px;\n"
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 320px;\n  box-shadow: var(--elevation-300);\n  background: var(--background-level-3);\n  border-radius: var(--border-radius-small);\n  padding: var(--spacing-small) var(--spacing-x-small);\n"
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: var(--spacing-small);\n  padding: var(--spacing-small) var(--spacing-regular);\n  margin-bottom: var(--spacing-x-small);\n  color: var(--foreground-primary);\n  font-size: var(--font-size-regular);\n  user-select: none;\n  text-decoration: none;\n  cursor: pointer;\n\n  ",
        " {\n    color: var(--foreground-secondary);\n  }\n\n  :focus {\n    outline: var(--border-width-small) solid var(--border-link-focus);\n    border-radius: var(--border-radius-small);\n  }\n\n  :hover:not(&[data-disabled]) {\n    background-color: var(--background-selected);\n    border-radius: var(--border-radius-small);\n    outline: none;\n  }\n\n  &[data-disabled] {\n    color: var(--foreground-disabled);\n    ",
        " {\n      color: var(--foreground-disabled);\n    }\n  }\n"
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n\n  &[data-state='open'] {\n    background: var(--background-button-secondary-active);\n    color: var(--foreground-button-secondary-hover);\n    border: 4px solid var(--background-button-destructive-disabled);\n  }\n"
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _taggedTemplateLiteral([
        "\n  padding: var(--spacing-small) var(--spacing-regular);\n"
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _taggedTemplateLiteral([
        "\n  height: 1px;\n  background-color: var(--border-default);\n  margin: var(--spacing-x-small);\n"
    ]);
    _templateObject104 = function _templateObject104() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-tertiary);\n  font-size: var(--font-size-small);\n  font-weight: var(--font-weight-bold);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-spacious);\n  padding: var(--spacing-small) var(--spacing-regular);\n"
    ]);
    _templateObject105 = function _templateObject105() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _taggedTemplateLiteral([
        "\n  fill: white;\n"
    ]);
    _templateObject106 = function _templateObject106() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject107() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject108() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n  padding-left: var(--spacing-regular);\n"
    ]);
    _templateObject109 = function _templateObject109() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject110 = function _templateObject110() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-secondary);\n  font-size: var(--font-size-small);\n  line-height: var(--line-height-large);\n"
    ]);
    _templateObject111 = function _templateObject111() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 32px;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  outline-offset: 0;\n"
    ]);
    _templateObject112 = function _templateObject112() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject113 = function _templateObject113() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    height: 20px;\n  }\n"
    ]);
    _templateObject114 = function _templateObject114() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: ",
        ";\n"
    ]);
    _templateObject115 = function _templateObject115() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  border-radius: 12px;\n  box-shadow: var(--elevation-300);\n  overflow: hidden;\n  min-width: 324px;\n  width: fit-content;\n"
    ]);
    _templateObject116 = function _templateObject116() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _taggedTemplateLiteral([
        "\n        cursor: grab;\n      "
    ]);
    _templateObject117 = function _templateObject117() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  background-color: var(--header-background);\n  border-bottom: 1px solid var(--header-divider);\n  display: flex;\n  justify-content: space-between;\n  height: 41px;\n  padding: 0 var(--spacing-small);\n\n  :hover {\n    ",
        "\n  }\n\n  ",
        " {\n    color: var(--header-foreground);\n    font-size: var(--font-size-medium);\n    font-weight: var(--font-weight-semibold);\n    margin-left: var(--spacing-small);\n  }\n\n  ",
        " {\n    color: var(--header-foreground);\n  }\n"
    ]);
    _templateObject118 = function _templateObject118() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n"
    ]);
    _templateObject119 = function _templateObject119() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: no-wrap;\n"
    ]);
    _templateObject120 = function _templateObject120() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: calc(100vh - ",
        "px - ",
        "px);\n  "
    ]);
    _templateObject121 = function _templateObject121() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--content-background);\n  color: var(--foreground-primary);\n  font-size: var(--font-size-small);\n  height: 100%;\n  overflow-y: auto;\n  padding: var(--spacing-regular);\n\n  // this is to prevent the content from being cut off\n  // when the window is resized to be smaller than the content\n  ",
        "\n"
    ]);
    _templateObject122 = function _templateObject122() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject123 = function _templateObject123() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject124 = function _templateObject124() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-right: var(--spacing-small);\n  font-size: var(--icon-size-regular);\n"
    ]);
    _templateObject125 = function _templateObject125() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject126 = function _templateObject126() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject127 = function _templateObject127() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-primary);\n"
    ]);
    _templateObject128 = function _templateObject128() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: var(--spacing-x-small);\n  color: var(--foreground-primary);\n"
    ]);
    _templateObject129 = function _templateObject129() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: var(--spacing-regular);\n"
    ]);
    _templateObject130 = function _templateObject130() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject131 = function _templateObject131() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-small);\n  padding-bottom: calc(var(--spacing-large) + var(--spacing-small));\n\n  ",
        " {\n    bottom: 4px;\n    font-size: var(--font-size-small);\n    position: absolute;\n    & > * {\n      font-size: var(--font-size-small);\n    }\n  }\n\n  ",
        " > * {\n    font-size: var(--font-size-small);\n  } ;\n"
    ]);
    _templateObject132 = function _templateObject132() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: row;\n  gap: var(--spacing-regular);\n"
    ]);
    _templateObject133 = function _templateObject133() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: var(--spacing-small);\n  flex-direction: column;\n  position: relative;\n  padding-bottom: calc(var(--spacing-x-large) + var(--spacing-small));\n\n  ",
        " {\n    font-size: var(--font-size-regular);\n    position: absolute;\n    bottom: 8px;\n    word-break: break-all;\n  }\n\n  ",
        " {\n    font-size: var(--font-size-regular);\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject134 = function _templateObject134() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: baseline;\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: var(--font-weight-bold);\n  text-decoration: none;\n  gap: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    border-radius: var(--border-radius-small);\n    outline-offset: 1px;\n    outline-color: var(--border-link-focus);\n    outline-width: var(--border-width-small);\n  }\n\n  &:active > span {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject135 = function _templateObject135() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject136 = function _templateObject136() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject137 = function _templateObject137() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _taggedTemplateLiteral([
        "\n  @keyframes overlayShow {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  background-color: var(--overlay-100);\n  position: fixed;\n  inset: 0;\n  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);\n"
    ]);
    _templateObject138 = function _templateObject138() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: var(--spacing-regular);\n  justify-content: right;\n"
    ]);
    _templateObject139 = function _templateObject139() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _taggedTemplateLiteral([
        "\n  width: 416px;\n  padding: var(--spacing-x-large);\n  ",
        " {\n    margin-top: var(--spacing-x-large);\n  }\n"
    ]);
    _templateObject140 = function _templateObject140() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _taggedTemplateLiteral([
        "\n  @keyframes contentShow {\n    from {\n      opacity: 0;\n      transform: translate(-50%, -48%) scale(0.96);\n    }\n    to {\n      opacity: 1;\n      transform: translate(-50%, -50%) scale(1);\n    }\n  }\n  color: var(--",
        ");\n  ",
        ";\n  background-color: var(--background-level-1);\n  border-radius: var(--border-radius-small, 6px);\n  box-shadow: var(--elevation-400);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  min-width: 416px;\n  width: 608px;\n  max-height: 100vh;\n  overflow: auto;\n  padding: var(--spacing-x-x-large);\n  animation: contentShow 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  display: flex;\n  gap: var(--spacing-regular);\n  flex-direction: column;\n\n  ",
        " {\n    margin-top: var(--spacing-x-x-large);\n  }\n\n  ",
        "\n"
    ]);
    _templateObject141 = function _templateObject141() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-small);\n"
    ]);
    _templateObject142 = function _templateObject142() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--",
        ");\n  position: absolute;\n  top: var(--spacing-large);\n  right: var(--spacing-large);\n  border: none;\n  background: none;\n  cursor: pointer;\n"
    ]);
    _templateObject143 = function _templateObject143() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _taggedTemplateLiteral([
        "\n  gap: 0;\n"
    ]);
    _templateObject144 = function _templateObject144() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-small, 4px);\n"
    ]);
    _templateObject145 = function _templateObject145() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-small, 8px);\n"
    ]);
    _templateObject146 = function _templateObject146() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-regular, 16px);\n"
    ]);
    _templateObject147 = function _templateObject147() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-large, 24px);\n"
    ]);
    _templateObject148 = function _templateObject148() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-large, 32px);\n"
    ]);
    _templateObject149 = function _templateObject149() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-x-large, 48px);\n"
    ]);
    _templateObject150 = function _templateObject150() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _taggedTemplateLiteral([
        "\n  gap: var(--spacing-x-x-x-large, 64px);\n"
    ]);
    _templateObject151 = function _templateObject151() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-large, 24px);\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject152 = function _templateObject152() {
        return data;
    };
    return data;
}
function _templateObject153() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject153 = function _templateObject153() {
        return data;
    };
    return data;
}
function _templateObject154() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-x-large) 0;\n  background-color: var(--background-level-1);\n\n  p {\n    align-self: center;\n  }\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    gap: var(--spacing-x-large);\n  }\n"
    ]);
    _templateObject154 = function _templateObject154() {
        return data;
    };
    return data;
}
function _templateObject155() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 1024px) {\n    width: 100%;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject155 = function _templateObject155() {
        return data;
    };
    return data;
}
function _templateObject156() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-primary);\n  font-size: var(--font-size-regular);\n  width: 52px;\n  margin: 0 var(--spacing-x-small);\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n"
    ]);
    _templateObject156 = function _templateObject156() {
        return data;
    };
    return data;
}
function _templateObject157() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 120px;\n"
    ]);
    _templateObject157 = function _templateObject157() {
        return data;
    };
    return data;
}
function _templateObject158() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject158 = function _templateObject158() {
        return data;
    };
    return data;
}
function _templateObject159() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject159 = function _templateObject159() {
        return data;
    };
    return data;
}
function _templateObject160() {
    var data = _taggedTemplateLiteral([
        "\n  @keyframes slideUpAndFade {\n    from {\n      opacity: 0;\n      transform: translateY(2px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slideRightAndFade {\n    from {\n      opacity: 0;\n      transform: translateX(-2px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slideDownAndFade {\n    from {\n      opacity: 0;\n      transform: translateY(-2px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  @keyframes slideLeftAndFade {\n    from {\n      opacity: 0;\n      transform: translateX(2px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  box-sizing: border-box;\n  background-color: var(--background-level-3);\n  border-radius: var(--border-radius-small);\n  box-shadow: var(--elevation-300);\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n  max-width: 416px;\n  min-width: 248px;\n  z-index: 300;\n  padding: var(--spacing-large);\n\n  :focus {\n    box-shadow: var(--elevation-300);\n  }\n\n  &[data-state='open'][data-side='top'] {\n    animation-name: slideDownAndFade;\n  }\n  &[data-state='open'][data-side='right'] {\n    animation-name: slideLeftAndFade;\n  }\n  &[data-state='open'][data-side='bottom'] {\n    animation-name: slideUpAndFade;\n  }\n  &[data-state='open'][data-side='left'] {\n    animation-name: slideRightAndFade;\n  }\n"
    ]);
    _templateObject160 = function _templateObject160() {
        return data;
    };
    return data;
}
function _templateObject161() {
    var data = _taggedTemplateLiteral([
        "\n  fill: var(--background-level-3);\n"
    ]);
    _templateObject161 = function _templateObject161() {
        return data;
    };
    return data;
}
function _templateObject162() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 40px;\n  height: 40px;\n  border: none;\n  cursor: pointer;\n  background: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject162 = function _templateObject162() {
        return data;
    };
    return data;
}
function _templateObject163() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject163 = function _templateObject163() {
        return data;
    };
    return data;
}
function _templateObject164() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: var(--spacing-small);\n  padding-bottom: var(--spacing-small);\n"
    ]);
    _templateObject164 = function _templateObject164() {
        return data;
    };
    return data;
}
function _templateObject165() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: right;\n  border: none;\n  background: none;\n"
    ]);
    _templateObject165 = function _templateObject165() {
        return data;
    };
    return data;
}
function _templateObject166() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject166 = function _templateObject166() {
        return data;
    };
    return data;
}
function _templateObject167() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--progress-default);\n  height: 100%;\n  border-top-left-radius: 100px;\n  border-bottom-left-radius: 100px;\n  transition: 0.25s ease;\n  background: ",
        ";\n"
    ]);
    _templateObject167 = function _templateObject167() {
        return data;
    };
    return data;
}
function _templateObject168() {
    var data = _taggedTemplateLiteral([
        "\n  height: 8px;\n  min-width: 100px;\n  border-radius: 100px;\n  overflow: hidden;\n  background: var(--color-neutral-100);\n\n  &[data-value='100'] {\n    ",
        " {\n      border-top-right-radius: 100px;\n      border-bottom-right-radius: 100px;\n    }\n  }\n"
    ]);
    _templateObject168 = function _templateObject168() {
        return data;
    };
    return data;
}
function _templateObject169() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject169 = function _templateObject169() {
        return data;
    };
    return data;
}
function _templateObject170() {
    var data = _taggedTemplateLiteral([
        "\n  all: unset;\n  border-radius: 100%;\n  border: 2px solid var(--foreground-secondary);\n  height: 20px;\n  max-width: 20px;\n  min-width: 20px;\n\n  &:hover {\n    border-color: var(--foreground-primary);\n  }\n\n  &[data-state='checked'] {\n    border: 2px solid var(--foreground-primary);\n  }\n\n  &:disabled,\n  &[disabled] {\n    border-color: var(--border-input-disabled);\n\n    & + * {\n      p {\n        color: var(--foreground-disabled);\n      }\n    }\n  }\n"
    ]);
    _templateObject170 = function _templateObject170() {
        return data;
    };
    return data;
}
function _templateObject171() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n\n  &::after {\n    content: '';\n    background-color: var(--border-boolean-active);\n    border-radius: 100%;\n    display: block;\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject171 = function _templateObject171() {
        return data;
    };
    return data;
}
function _templateObject172() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 12px 8px;\n  user-select: none;\n\n  &:hover {\n    background-color: var(--background-boolean-hover);\n    border-radius: var(--spacing-small);\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: 2px solid var(--border-boolean-active-hover);\n    border-radius: var(--spacing-small);\n  }\n"
    ]);
    _templateObject172 = function _templateObject172() {
        return data;
    };
    return data;
}
function _templateObject173() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  &[disabled] {\n    cursor: not-allowed;\n    user-events: none;\n\n    ",
        " {\n      cursor: not-allowed;\n      user-events: none;\n    }\n  }\n"
    ]);
    _templateObject173 = function _templateObject173() {
        return data;
    };
    return data;
}
function _templateObject174() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-primary);\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-weight-regular);\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject174 = function _templateObject174() {
        return data;
    };
    return data;
}
function _templateObject175() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: var(--spacing-x-large);\n  color: var(--foreground-tertiary);\n"
    ]);
    _templateObject175 = function _templateObject175() {
        return data;
    };
    return data;
}
function _templateObject176() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject176 = function _templateObject176() {
        return data;
    };
    return data;
}
function _templateObject177() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: var(--border-radius-small);\n  min-height: 96px;\n  box-shadow: var(--elevation-100);\n  padding: var(--spacing-x-large);\n  background: var(--background-level-1);\n\n  & & {\n    box-shadow: none;\n    border: 1px solid var(--border-default);\n  }\n"
    ]);
    _templateObject177 = function _templateObject177() {
        return data;
    };
    return data;
}
function _templateObject178() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--color-neutral-300);\n  position: relative;\n  flex-grow: 1;\n  border-radius: 9999px;\n\n  &[data-orientation='horizontal'] {\n    height: var(--spacing-small);\n  }\n"
    ]);
    _templateObject178 = function _templateObject178() {
        return data;
    };
    return data;
}
function _templateObject179() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  background-color: var(--color-blurple-600);\n  border: 2px solid var(--color-neutral-0);\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  box-sizing: content-box;\n\n  &:hover {\n    background-color: var(--color-blurple-700);\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px var(--color-blue-600);\n  }\n\n  &:active:focus {\n    border: 2px solid var(--color-blurple-400);\n    box-shadow: 0 0 0 2px var(--color-blurple-400);\n  }\n\n  &[data-disabled] {\n    border: 2px solid var(--color-neutral-300);\n    background-color: var(--color-neutral-500);\n  }\n"
    ]);
    _templateObject179 = function _templateObject179() {
        return data;
    };
    return data;
}
function _templateObject180() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 174px;\n\n  &[data-orientation='horizontal'] {\n    height: var(--spacing-x-small);\n  }\n\n  ",
        " {\n    &[data-orientation='horizontal'] {\n      height: var(--spacing-x-small);\n    }\n  }\n\n  ",
        " {\n    width: 12px;\n    height: 12px;\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject180 = function _templateObject180() {
        return data;
    };
    return data;
}
function _templateObject181() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  user-select: none;\n  touch-action: none;\n  min-width: 320px;\n  ",
        "\n\n  &[data-orientation='horizontal'] {\n    height: var(--spacing-small);\n  }\n"
    ]);
    _templateObject181 = function _templateObject181() {
        return data;
    };
    return data;
}
function _templateObject182() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  background-color: var(--color-blurple-600);\n  border-radius: 9999px;\n  height: 100%;\n\n  &[data-disabled] {\n    background-color: var(--color-neutral-500);\n  }\n"
    ]);
    _templateObject182 = function _templateObject182() {
        return data;
    };
    return data;
}
function _templateObject183() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject183 = function _templateObject183() {
        return data;
    };
    return data;
}
function _templateObject184() {
    var data = _taggedTemplateLiteral([
        "\n  .st0 {\n    fill: #fff;\n  }\n"
    ]);
    _templateObject184 = function _templateObject184() {
        return data;
    };
    return data;
}
function _templateObject185() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n"
    ]);
    _templateObject185 = function _templateObject185() {
        return data;
    };
    return data;
}
function _templateObject186() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n  }\n"
    ]);
    _templateObject186 = function _templateObject186() {
        return data;
    };
    return data;
}
function _templateObject187() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject187 = function _templateObject187() {
        return data;
    };
    return data;
}
function _templateObject188() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    left: 18px;\n    ",
        ": 18px;\n  }\n  100% {\n    left: 18px;\n    ",
        ": 42px;\n  }\n"
    ]);
    _templateObject188 = function _templateObject188() {
        return data;
    };
    return data;
}
function _templateObject189() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    background: transparent;\n    border: 4px solid transparent;\n\n    ",
        "\n  }\n  100% {\n    background: transparent;\n    border: 4px solid transparent;\n    height: 50px;\n    left: -5px;\n    width: 50px;\n\n    ",
        ": -2px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject189 = function _templateObject189() {
        return data;
    };
    return data;
}
function _templateObject190() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n"
    ]);
    _templateObject190 = function _templateObject190() {
        return data;
    };
    return data;
}
function _templateObject191() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 0.6s ease-in-out 1, ",
        " 1.5s linear 0.5s infinite;\n  background: var(--gradient-blurple);\n  border-radius: 50%;\n  display: block;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  height: 40px;\n  position: relative;\n  transform: translateZ(0);\n  width: 40px;\n  will-change: transform;\n"
    ]);
    _templateObject191 = function _templateObject191() {
        return data;
    };
    return data;
}
function _templateObject192() {
    var data = _taggedTemplateLiteral([
        "\n    animation: ",
        " 0.5s linear 1 0.5s forwards,\n      ",
        " 0.5s linear 1 1s forwards,\n      ",
        " 0.5s linear 1 3s forwards;\n\n    ",
        ": 18px;\n  "
    ]);
    _templateObject192 = function _templateObject192() {
        return data;
    };
    return data;
}
function _templateObject193() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--color-blurple-600);\n  border-radius: 50%;\n  height: 6px;\n  left: 18px;\n  position: absolute;\n  width: 6px;\n  transform: translateZ(0);\n  will-change: transform;\n\n  ",
        "\n"
    ]);
    _templateObject193 = function _templateObject193() {
        return data;
    };
    return data;
}
function _templateObject194() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  animation: ",
        " 0.6s ease-in-out 1;\n  background: var(--gradient-blurple);\n  border-radius: 100%;\n  display: flex;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  height: 40px;\n  justify-content: center;\n  position: absolute;\n  transform: translateZ(0);\n  width: 40px;\n  will-change: transform;\n"
    ]);
    _templateObject194 = function _templateObject194() {
        return data;
    };
    return data;
}
function _templateObject195() {
    var data = _taggedTemplateLiteral([
        "\n  width: 20px;\n  height: 20px;\n"
    ]);
    _templateObject195 = function _templateObject195() {
        return data;
    };
    return data;
}
function _templateObject196() {
    var data = _taggedTemplateLiteral([
        "\n  --background-level-1: var(--color-neutral-0);\n  --border-default: var(--color-neutral-200);\n  --border-table-active: var(--color-neutral-700);\n\n  background: var(--background-level-1);\n  border-collapse: collapse;\n  color: var(--color-neutral-700);\n  font-size: var(--font-size-regular);\n  width: 100%;\n"
    ]);
    _templateObject196 = function _templateObject196() {
        return data;
    };
    return data;
}
function _templateObject197() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-neutral-800);\n"
    ]);
    _templateObject197 = function _templateObject197() {
        return data;
    };
    return data;
}
function _templateObject198() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: var(--border-width-x-small) solid var(--border-default);\n  vertical-align: middle;\n  overflow-wrap: anywhere;\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  @media print {\n    white-space: normal;\n  }\n"
    ]);
    _templateObject198 = function _templateObject198() {
        return data;
    };
    return data;
}
function _templateObject199() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: var(--border-width-x-small) solid var(--border-default);\n  font-weight: var(--font-weight-bold);\n  padding: var(--spacing-large) var(--spacing-regular) var(--spacing-small)\n    var(--spacing-regular);\n\n  ",
        "\n\n  ",
        "\n  \n    ",
        "\n  \n    @media print {\n    width: auto;\n  }\n"
    ]);
    _templateObject199 = function _templateObject199() {
        return data;
    };
    return data;
}
function _templateObject200() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n"
    ]);
    _templateObject200 = function _templateObject200() {
        return data;
    };
    return data;
}
function _templateObject201() {
    var data = _taggedTemplateLiteral([
        "\n  overflow-wrap: anywhere;\n"
    ]);
    _templateObject201 = function _templateObject201() {
        return data;
    };
    return data;
}
function _templateObject202() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject202 = function _templateObject202() {
        return data;
    };
    return data;
}
function _templateObject203() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject203 = function _templateObject203() {
        return data;
    };
    return data;
}
function _templateObject204() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject204 = function _templateObject204() {
        return data;
    };
    return data;
}
function _templateObject205() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject205 = function _templateObject205() {
        return data;
    };
    return data;
}
function _templateObject206() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject206 = function _templateObject206() {
        return data;
    };
    return data;
}
function _templateObject207() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject207 = function _templateObject207() {
        return data;
    };
    return data;
}
function _templateObject208() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject208 = function _templateObject208() {
        return data;
    };
    return data;
}
function _templateObject209() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 var(--spacing-large);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject209 = function _templateObject209() {
        return data;
    };
    return data;
}
function _templateObject210() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject210 = function _templateObject210() {
        return data;
    };
    return data;
}
function _templateObject211() {
    var data = _taggedTemplateLiteral([
        "\n      > * {\n        all: unset;\n        ",
        ";\n      }\n    "
    ]);
    _templateObject211 = function _templateObject211() {
        return data;
    };
    return data;
}
function _templateObject212() {
    var data = _taggedTemplateLiteral([
        "\n  all: unset;\n  cursor: pointer;\n  color: var(--foreground-secondary);\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-weight-bold);\n  text-align: center;\n  transition: color 0.2s ease-in, background 0.2s ease-in;\n  white-space: nowrap;\n  min-height: 46px;\n  padding: var(--border-width-small);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ",
        "\n\n  ",
        " {\n    font-size: var(--icon-size-regular);\n    margin-right: var(--spacing-small);\n  }\n\n  &:hover {\n    color: var(--foreground-link-active);\n    background: var(--tabs-hover-background);\n    box-shadow: inset 0 -1px 0 0 var(--border-default),\n      0 1px 0 0 var(--border-default);\n  }\n\n  &:focus-visible {\n    color: var(--border-link-focus);\n    background: var(--tabs-hover-background);\n\n    ",
        " {\n      outline: var(--border-width-small) solid var(--border-link-focus);\n      border-radius: 4px;\n    }\n  }\n\n  &[data-state='active'] {\n    color: var(--foreground-link-active);\n\n    &:hover {\n      background: var(--tabs-active-hover-background);\n    }\n\n    &:focus {\n      background: var(--tabs-active-hover-background);\n    }\n  }\n"
    ]);
    _templateObject212 = function _templateObject212() {
        return data;
    };
    return data;
}
function _templateObject213() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  height: 2px;\n  background: var(--foreground-link-active);\n  transition: left 0.4s cubic-bezier(0.33, 0.14, 0.13, 0.97);\n"
    ]);
    _templateObject213 = function _templateObject213() {
        return data;
    };
    return data;
}
function _templateObject214() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid var(--border-default);\n  display: flex;\n  position: relative;\n  overflow-x: scroll;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  background-image: \n    /* Shadows */ linear-gradient(to right, white, white),\n    linear-gradient(to right, white, white),\n    /* Shadow covers */\n      linear-gradient(to right, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0)),\n    linear-gradient(to left, rgba(0, 0, 0, 0.1), rgba(255, 255, 255, 0));\n\n  background-position: left center, right center, left center, right center;\n  background-repeat: no-repeat;\n  background-color: white;\n  background-size: 40px 100%, 40px 100%, 20px 100%, 20px 100%;\n\n  /* Opera doesn't support this in the shorthand */\n  background-attachment: local, local, scroll, scroll;\n"
    ]);
    _templateObject214 = function _templateObject214() {
        return data;
    };
    return data;
}
function _templateObject215() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    font-size: var(--font-size-small);\n    padding: var(--spacing-small);\n\n    ",
        " {\n      font-size: var(--icon-size-small);\n    }\n  }\n"
    ]);
    _templateObject215 = function _templateObject215() {
        return data;
    };
    return data;
}
function _templateObject216() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject216 = function _templateObject216() {
        return data;
    };
    return data;
}
function _templateObject217() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    flex: 1;\n  }\n"
    ]);
    _templateObject217 = function _templateObject217() {
        return data;
    };
    return data;
}
function _templateObject218() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject218 = function _templateObject218() {
        return data;
    };
    return data;
}
function _templateObject219() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject219 = function _templateObject219() {
        return data;
    };
    return data;
}
function _templateObject220() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject220 = function _templateObject220() {
        return data;
    };
    return data;
}
function _templateObject221() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject221 = function _templateObject221() {
        return data;
    };
    return data;
}
function _templateObject222() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject222 = function _templateObject222() {
        return data;
    };
    return data;
}
function _templateObject223() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject223 = function _templateObject223() {
        return data;
    };
    return data;
}
function _templateObject224() {
    var data = _taggedTemplateLiteral([
        "\n  border: none;\n  outline: none;\n  background-color: transparent;\n  border-radius: var(--border-radius-small);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-regular);\n  line-height: var(--line-height-regular);\n  color: var(--foreground-primary);\n  padding: var(--spacing-small) var(--spacing-regular);\n  min-height: 40px;\n\n  ::placeholder {\n    font-style: italic;\n    color: var(--foreground-input-placeholder);\n  }\n"
    ]);
    _templateObject224 = function _templateObject224() {
        return data;
    };
    return data;
}
function _templateObject225() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-input-disabled);\n  border: var(--border-width-x-small) solid var(--border-input-disabled);\n  background: var(--background-input-disabled);\n  outline: none;\n  cursor: not-allowed;\n\n  ",
        " {\n    background: var(--background-input-disabled);\n    cursor: not-allowed;\n  }\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--border-input-disabled);\n  }\n"
    ]);
    _templateObject225 = function _templateObject225() {
        return data;
    };
    return data;
}
function _templateObject226() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--color-pink-50);\n  border: var(--border-width-x-small) solid var(--border-input-error);\n\n  &:hover {\n    border: var(--border-width-x-small) solid var(--border-input-error);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--border-input-error-outline);\n    border: var(--border-width-x-small) solid var(--border-input-error);\n  }\n"
    ]);
    _templateObject226 = function _templateObject226() {
        return data;
    };
    return data;
}
function _templateObject227() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: var(--background-input-default);\n  border: var(--border-width-x-small) solid var(--border-input-read-only);\n  outline: none;\n"
    ]);
    _templateObject227 = function _templateObject227() {
        return data;
    };
    return data;
}
function _templateObject228() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-secondary);\n  text-align: right;\n  line-height: var(--line-height-regular);\n  height: calc(var(--spacing-large) + var(--spacing-x-small));\n  padding: var(--spacing-x-small) var(--spacing-regular);\n"
    ]);
    _templateObject228 = function _templateObject228() {
        return data;
    };
    return data;
}
function _templateObject229() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ", ",
        " {\n    font-size: var(--font-size-small);\n  }\n  ",
        " {\n    padding-top: var(--spacing-small);\n  }\n"
    ]);
    _templateObject229 = function _templateObject229() {
        return data;
    };
    return data;
}
function _templateObject230() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  resize: both;\n  overflow: hidden;\n  position: relative;\n  padding: var(--spacing-small) 0 0;\n  min-height: calc(40px + 36px);\n\n  ",
        " {\n    resize: none;\n    padding-top: 0;\n    padding-bottom: 0;\n    flex: 1;\n  }\n"
    ]);
    _templateObject230 = function _templateObject230() {
        return data;
    };
    return data;
}
function _templateObject231() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  overflow: hidden;\n  min-height: 40px;\n  background-color: var(--background-input-default);\n  border: var(--border-width-x-small) solid var(--border-input-default);\n  border-radius: var(--border-radius-small);\n\n  &:hover {\n    outline: none;\n    border: var(--border-width-x-small) solid var(--border-input-hover);\n  }\n\n  &:focus-within {\n    outline: var(--border-width-small) solid var(--border-input-active-outline);\n  }\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject231 = function _templateObject231() {
        return data;
    };
    return data;
}
function _templateObject232() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject232 = function _templateObject232() {
        return data;
    };
    return data;
}
function _templateObject233() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: var(--font-size-regular);\n"
    ]);
    _templateObject233 = function _templateObject233() {
        return data;
    };
    return data;
}
function _templateObject234() {
    var data = _taggedTemplateLiteral([
        "\n  width: var(--spacing-regular);\n  animation: spinner 0.6s linear infinite;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject234 = function _templateObject234() {
        return data;
    };
    return data;
}
function _templateObject235() {
    var data = _taggedTemplateLiteral([
        "\n  background: var(--background-toggle-button-label);\n  color: var(--foreground-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px;\n  font-weight: var(--font-weight-semibold);\n  width: 100%;\n"
    ]);
    _templateObject235 = function _templateObject235() {
        return data;
    };
    return data;
}
function _templateObject236() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ", img {\n    width: 56px;\n    height: 56px;\n    color: var(--foreground-button-secondary-default);\n  }\n"
    ]);
    _templateObject236 = function _templateObject236() {
        return data;
    };
    return data;
}
function _templateObject237() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  background: var(--background-level-1);\n  border-radius: var(--border-radius-small);\n  border: 1px solid var(--border-input-default);\n  cursor: pointer;\n  padding: 18px 0px 0px 0px;\n  height: 120px;\n  max-width: 260px;\n  min-width: 140px;\n  overflow: hidden;\n  flex: 1 0 calc((100% / 4) - 10px);\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n\n  > ",
        " {\n    padding-bottom: 6px;\n  }\n\n  &[data-state='on'] {\n    padding-top: 17px;\n    border: 2px solid var(--border-input-active);\n    > ",
        " {\n      padding-bottom: 5px;\n    }\n  }\n\n  :hover {\n    border-width: 2px;\n    border-color: var(--border-input-hover);\n    background: var(--background-selected);\n    padding-top: 17px;\n    > ",
        " {\n      color: var(--foreground-primary);\n      padding-bottom: 5px;\n    }\n  }\n"
    ]);
    _templateObject237 = function _templateObject237() {
        return data;
    };
    return data;
}
function _templateObject238() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--spacing-regular);\n"
    ]);
    _templateObject238 = function _templateObject238() {
        return data;
    };
    return data;
}
function _templateObject239() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject239 = function _templateObject239() {
        return data;
    };
    return data;
}
function _templateObject240() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject240 = function _templateObject240() {
        return data;
    };
    return data;
}
function _templateObject241() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n"
    ]);
    _templateObject241 = function _templateObject241() {
        return data;
    };
    return data;
}
function _templateObject242() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 300;\n"
    ]);
    _templateObject242 = function _templateObject242() {
        return data;
    };
    return data;
}
function _templateObject243() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  background-color: var(--background-tooltip);\n  border-color: var(--background-tooltip);\n  border-radius: var(--border-radius-small);\n  color: var(--foreground-tooltip);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-small);\n  line-height: 1.5;\n  padding: var(--spacing-small) var(--spacing-regular);\n  text-align: center;\n  white-space: normal;\n\n  ",
        "\n"
    ]);
    _templateObject243 = function _templateObject243() {
        return data;
    };
    return data;
}
function _templateObject244() {
    var data = _taggedTemplateLiteral([
        "\n  fill: var(--background-tooltip);\n"
    ]);
    _templateObject244 = function _templateObject244() {
        return data;
    };
    return data;
}
function _templateObject245() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject245 = function _templateObject245() {
        return data;
    };
    return data;
}
function _templateObject246() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject246 = function _templateObject246() {
        return data;
    };
    return data;
}
function _templateObject247() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-tertiary);\n"
    ]);
    _templateObject247 = function _templateObject247() {
        return data;
    };
    return data;
}
function _templateObject248() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  height: var(--spacing-regular);\n  width: var(--spacing-regular);\n  margin-top: 2px;\n  // Donot update without prior design discussion\n  border-radius: 3px;\n  outline: none;\n  border: var(--border-width-small) solid var(--border-boolean-default);\n  background: none;\n\n  &[data-state='checked'] {\n    border: var(--border-width-small) solid\n      var(--background-interactive-active-default);\n  }\n"
    ]);
    _templateObject248 = function _templateObject248() {
        return data;
    };
    return data;
}
function _templateObject249() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  color: var(--foreground-inverse);\n  background-color: var(--background-interactive-active-default);\n"
    ]);
    _templateObject249 = function _templateObject249() {
        return data;
    };
    return data;
}
function _templateObject250() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: var(--spacing-small);\n  color: var(--foreground-primary);\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-weight-regular);\n  align-items: center;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject250 = function _templateObject250() {
        return data;
    };
    return data;
}
function _templateObject251() {
    var data = _taggedTemplateLiteral([
        "\n  border: var(--border-width-x-small) solid var(--border-error);\n\n  ",
        " {\n    color: var(--foreground-primary);\n  }\n\n  ",
        " {\n    color: var(--foreground-tertiary);\n  }\n\n  ",
        " {\n    background-color: var(--background-interactive-error-default);\n  }\n\n  ",
        " {\n    border: var(--border-width-small) solid var(--foreground-error);\n\n    &[data-state='checked'] {\n      border: var(--border-width-small) solid\n        var(--background-interactive-error-default);\n    }\n  }\n\n  &:hover {\n    border: var(--border-width-x-small) solid var(--border-boolean-error-hover);\n    background: none;\n\n    ",
        " {\n      color: var(--foreground-primary);\n    }\n\n    ",
        " {\n      color: var(--foreground-tertiary);\n    }\n\n    ",
        " {\n      background-color: var(--border-boolean-error-hover);\n    }\n\n    ",
        " {\n      border: var(--border-width-small) solid var(--border-boolean-error-hover);\n\n      &[data-state='checked'] {\n        border: var(--border-width-small) solid\n          var(--border-boolean-error-hover);\n      }\n    }\n  }\n\n  &:focus-within {\n    border: var(--border-width-x-small) solid var(--border-input-error);\n    box-shadow: 0 0 0 var(--border-width-small)\n      var(--border-input-error-outline);\n  }\n"
    ]);
    _templateObject251 = function _templateObject251() {
        return data;
    };
    return data;
}
function _templateObject252() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: not-allowed;\n\n  ",
        " {\n    color: var(--foreground-disabled);\n    cursor: not-allowed;\n  }\n\n  ",
        " {\n    color: var(--foreground-disabled);\n  }\n\n  ",
        " {\n    border: var(--border-width-small) solid var(--border-input-disabled);\n\n    &[data-state='checked'] {\n      border: var(--border-width-small) solid var(--background-disabled);\n    }\n  }\n\n  ",
        " {\n    background-color: var(--background-disabled);\n  }\n\n  &:hover {\n    background: none;\n\n    ",
        " {\n      color: var(--foreground-disabled);\n    }\n\n    ",
        " {\n      background-color: var(--background-disabled);\n    }\n\n    ",
        " {\n      color: var(--foreground-disabled);\n    }\n\n    ",
        " {\n      border: var(--border-width-small) solid var(--border-input-disabled);\n\n      &[data-state='checked'] {\n        border: var(--border-width-small) solid var(--background-disabled);\n      }\n    }\n  }\n"
    ]);
    _templateObject252 = function _templateObject252() {
        return data;
    };
    return data;
}
function _templateObject253() {
    var data = _taggedTemplateLiteral([
        "\n  border: var(--border-width-x-small) solid transparent;\n  border-radius: var(--spacing-small);\n  max-width: 320px;\n  width: 100%;\n\n  &:hover {\n    background-color: var(--background-boolean-hover);\n\n    ",
        " {\n      color: var(--foreground-primary);\n    }\n\n    ",
        " {\n      background-color: var(--background-interactive-active-hover);\n    }\n\n    ",
        " {\n      color: var(--foreground-secondary);\n    }\n\n    ",
        " {\n      border: var(--border-width-small) solid var(--border-boolean-hover);\n\n      &[data-state='checked'] {\n        border: var(--border-width-small) solid\n          var(--background-interactive-active-hover);\n      }\n    }\n  }\n\n  &:focus-within {\n    border: var(--border-width-x-small) solid var(--border-boolean-active-hover);\n    box-shadow: 0 0 0 var(--border-width-small)\n      var(--border-input-active-outline);\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject253 = function _templateObject253() {
        return data;
    };
    return data;
}
function _templateObject254() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject254 = function _templateObject254() {
        return data;
    };
    return data;
}
function _templateObject255() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid var(--border-default);\n"
    ]);
    _templateObject255 = function _templateObject255() {
        return data;
    };
    return data;
}
function _templateObject256() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: var(--elevation-100);\n"
    ]);
    _templateObject256 = function _templateObject256() {
        return data;
    };
    return data;
}
function _templateObject257() {
    var data = _taggedTemplateLiteral([
        "\n  padding: var(--spacing-regular);\n"
    ]);
    _templateObject257 = function _templateObject257() {
        return data;
    };
    return data;
}
function _templateObject258() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 40px;\n  justify-content: space-between;\n"
    ]);
    _templateObject258 = function _templateObject258() {
        return data;
    };
    return data;
}
function _templateObject259() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject259 = function _templateObject259() {
        return data;
    };
    return data;
}
function _templateObject260() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n"
    ]);
    _templateObject260 = function _templateObject260() {
        return data;
    };
    return data;
}
function _templateObject261() {
    var data = _taggedTemplateLiteral([
        "\n  color: var(--foreground-primary);\n"
    ]);
    _templateObject261 = function _templateObject261() {
        return data;
    };
    return data;
}
function _templateObject262() {
    var data = _taggedTemplateLiteral([
        "\n  // Reset button styles\n  border: none;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  -webkit-appearance: none;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n"
    ]);
    _templateObject262 = function _templateObject262() {
        return data;
    };
    return data;
}
function _templateObject263() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  color: var(--foreground-secondary);\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject263 = function _templateObject263() {
        return data;
    };
    return data;
}
function _templateObject264() {
    var data = _taggedTemplateLiteral([
        "\n        font-size: var(--font-size-small);\n      "
    ]);
    _templateObject264 = function _templateObject264() {
        return data;
    };
    return data;
}
function _templateObject265() {
    var data = _taggedTemplateLiteral([
        "\n        font-size: var(--font-size-x-large);\n      "
    ]);
    _templateObject265 = function _templateObject265() {
        return data;
    };
    return data;
}
function _templateObject266() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: var(--border-radius-small);\n  background: var(--background-level-1);\n  padding: var(--spacing-x-large);\n  display: flex;\n  flex-direction: column;\n  box-sizing: content-box;\n  outline-offset: 4px;\n  outline-color: var(--border-button-focus);\n  transition: background-color 0.3s ease-in-out;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  \n  &[role=\"option\"] {\n    &[aria-selected='true'] {\n      border: var(--border-width-small) solid var(--border-boolean-active);\n      background: var(--background-info, #f5faff);\n      // We need to remove the padding from the container to avoid blinking\n      // -1px is because of the difference between initial border and the selected one\n      padding: calc(var(--spacing-x-large) - 1px);\n    }\n\n    &[aria-disabled='true'] {\n      ",
        ", ",
        ", ",
        " {\n        color: var(--foreground-disabled, #8492ae);\n      }\n\n      ",
        ", ",
        " {\n        color: var(--foreground-disabled, #8492ae);\n      }\n    }\n\n    :not([aria-disabled='true']):hover {\n      cursor: pointer;\n    }\n\n    :not([aria-selected='true']):not([aria-disabled='true']):hover {\n      background: var(--background-selected, #f7faff);\n    }\n  }\n\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject266 = function _templateObject266() {
        return data;
    };
    return data;
}
function _templateObject267() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-regular);\n\n  > * {\n    flex-basis: 300px;\n    min-width: 0;\n    flex-shrink: 0;\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject267 = function _templateObject267() {
        return data;
    };
    return data;
}
function _templateObject268() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject268 = function _templateObject268() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    Alert: function() {
        return Alert_default;
    },
    Badge: function() {
        return Badge_default;
    },
    Button: function() {
        return Button_default;
    },
    ButtonGroup: function() {
        return ButtonGroup_default;
    },
    Checkbox: function() {
        return Checkbox_default;
    },
    Code: function() {
        return Code_default;
    },
    DEFAULT_TEXT_COLOR_TOKEN: function() {
        return DEFAULT_TEXT_COLOR_TOKEN;
    },
    DatePicker: function() {
        return DatePicker_default;
    },
    DropdownMenu: function() {
        return DropdownMenu_exports;
    },
    FloatingPanel: function() {
        return FloatingPanel_default;
    },
    Form: function() {
        return Form_default;
    },
    FormField: function() {
        return FormField_default;
    },
    Icon: function() {
        return Icon_default;
    },
    InlineMessage: function() {
        return InlineMessage_default;
    },
    Input: function() {
        return Input_default;
    },
    Label: function() {
        return Label_default;
    },
    Link: function() {
        return Link_default;
    },
    Metric: function() {
        return Metric_default;
    },
    Modal: function() {
        return Modal_default;
    },
    Pagination: function() {
        return Pagination_default;
    },
    Popover: function() {
        return Popover_default;
    },
    Portal: function() {
        return Portal_default;
    },
    PrimitiveText: function() {
        return PrimitiveText;
    },
    Progress: function() {
        return Progress_default;
    },
    Radio: function() {
        return Radio_default;
    },
    Row: function() {
        return Row_default;
    },
    Section: function() {
        return Section_default;
    },
    Select: function() {
        return Select_default;
    },
    SelectOption: function() {
        return SelectOption_default;
    },
    Slider: function() {
        return Slider_default;
    },
    Spinner: function() {
        return Spinner_default;
    },
    Stack: function() {
        return Stack_default;
    },
    SubTitle: function() {
        return SubTitle_default;
    },
    Table: function() {
        return Table_default;
    },
    Tabs: function() {
        return Tabs_default;
    },
    Text: function() {
        return Text_default;
    },
    TextArea: function() {
        return TextArea_default;
    },
    Title: function() {
        return Title_default;
    },
    Toaster: function() {
        return Toaster;
    },
    ToggleButton: function() {
        return ToggleButton_default;
    },
    ToggleGroup: function() {
        return ToggleGroup_default;
    },
    Tooltip: function() {
        return Tooltip_default;
    },
    regularTextProps: function() {
        return regularTextProps;
    },
    toast: function() {
        return Toast_default;
    },
    usePagination: function() {
        return usePagination;
    },
    useSortTable: function() {
        return useSortTable;
    }
});
module.exports = __toCommonJS(src_exports);
// src/components/Alert/Alert.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var import_faCircleInfo = require("@fortawesome/pro-solid-svg-icons/faCircleInfo");
var import_faCircleCheck = require("@fortawesome/pro-solid-svg-icons/faCircleCheck");
var import_faXmark = require("@fortawesome/pro-solid-svg-icons/faXmark");
var import_faHexagonExclamation = require("@fortawesome/pro-solid-svg-icons/faHexagonExclamation");
var import_faTriangleExclamation = require("@fortawesome/pro-solid-svg-icons/faTriangleExclamation");
// src/components/Icon/Icon.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var import_styled_components = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var small = import_styled_components.css(_templateObject());
var regular = import_styled_components.css(_templateObject1());
var large = import_styled_components.css(_templateObject2());
var xLarge = import_styled_components.css(_templateObject3());
var IconWithSize = (0, import_styled_components.default)(import_react_fontawesome.FontAwesomeIcon)(_templateObject4(), function(props) {
    return props.$size === "small" && small;
}, function(props) {
    return props.$size === "regular" && regular;
}, function(props) {
    return props.$size === "large" && large;
}, function(props) {
    return props.$size === "x-large" && xLarge;
}, function(param) {
    var $colorToken = param.$colorToken;
    return $colorToken && "color: var(--".concat($colorToken, ");");
});
var Icon = function(_param) {
    var _colorToken = _param.colorToken, colorToken = _colorToken === void 0 ? "" : _colorToken, icon = _param.icon, _size = _param.size, size = _size === void 0 ? "regular" : _size, htmlAttrs = _objectWithoutProperties(_param, [
        "colorToken",
        "icon",
        "size"
    ]);
    if (!icon) {
        return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWithSize, _objectSpread({
        $colorToken: colorToken,
        icon: icon,
        $size: size
    }, htmlAttrs));
};
Icon.displayName = "Icon";
var Icon_default = (0, import_styled_components.default)(Icon)(_templateObject5());
// src/components/Typography/Code.tsx
var import_styled_components3 = __toESM(require("styled-components"));
// src/components/Typography/Text.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var small2 = import_styled_components2.css(_templateObject6());
var regular2 = import_styled_components2.css(_templateObject7());
var medium = import_styled_components2.css(_templateObject8());
var large2 = import_styled_components2.css(_templateObject9());
var bold = import_styled_components2.css(_templateObject10());
var semibold = import_styled_components2.css(_templateObject11());
var regularWeight = import_styled_components2.css(_templateObject12());
var dense = import_styled_components2.css(_templateObject13());
var spacious = import_styled_components2.css(_templateObject14());
var regularTextProps = regular2;
var DEFAULT_TEXT_COLOR_TOKEN = "foreground-secondary";
var PrimitiveText = import_styled_components2.default.p(_templateObject15(), regular2, regularWeight, function(param) {
    var $size = param.$size;
    return $size === "small" && small2;
}, function(param) {
    var $size = param.$size;
    return $size === "medium" && medium;
}, function(param) {
    var $size = param.$size;
    return $size === "large" && large2;
}, function(param) {
    var $weight = param.$weight;
    return $weight === "bold" && bold;
}, function(param) {
    var $weight = param.$weight;
    return $weight === "semibold" && semibold;
}, function(param) {
    var $colorToken = param.$colorToken;
    return $colorToken && "color: var(--".concat($colorToken, ");");
}, function(param) {
    var $letterSpacing = param.$letterSpacing;
    return $letterSpacing === "dense" && dense;
}, function(param) {
    var $letterSpacing = param.$letterSpacing;
    return $letterSpacing === "spacious" && spacious;
});
var Text = function(_param) /* @__PURE__ */ {
    var size = _param.size, weight = _param.weight, _colorToken = _param.colorToken, colorToken = _colorToken === void 0 ? DEFAULT_TEXT_COLOR_TOKEN : _colorToken, letterSpacing = _param.letterSpacing, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "size",
        "weight",
        "colorToken",
        "letterSpacing",
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(PrimitiveText, _objectSpreadProps(_objectSpread({
        $size: size,
        $weight: weight,
        $colorToken: colorToken,
        $letterSpacing: letterSpacing
    }, htmlAttrs), {
        children: children
    }));
};
var Text_default = (0, import_styled_components2.default)(Text)(_templateObject16());
// src/components/Typography/Code.tsx
var Code = (0, import_styled_components3.default)(Text_default)(_templateObject17());
var Code_default = Code;
// src/components/Typography/Title.tsx
var import_styled_components4 = __toESM(require("styled-components"));
var Title = import_styled_components4.default.h1(_templateObject18());
var Title_default = Title;
// src/components/Typography/SubTitle.tsx
var import_styled_components5 = __toESM(require("styled-components"));
var SubTitleStyles = import_styled_components5.css(_templateObject19());
var SubTitle = import_styled_components5.default.h2(_templateObject20(), SubTitleStyles);
var SubTitle_default = SubTitle;
// src/components/Alert/styled.ts
var import_styled_components9 = __toESM(require("styled-components"));
// src/components/Stack/Stack.tsx
var import_styled_components7 = __toESM(require("styled-components"));
// src/components/Stack/styled.ts
var import_styled_components6 = __toESM(require("styled-components"));
var none = import_styled_components6.css(_templateObject21());
var xsmall = import_styled_components6.css(_templateObject22());
var small3 = import_styled_components6.css(_templateObject23());
var regular3 = import_styled_components6.css(_templateObject24());
var large3 = import_styled_components6.css(_templateObject25());
var xlarge = import_styled_components6.css(_templateObject26());
var xxlarge = import_styled_components6.css(_templateObject27());
var xxxlarge = import_styled_components6.css(_templateObject28());
var StackWrapper = import_styled_components6.default.div(_templateObject29(), function(props) {
    return props.$xAlign && {
        "align-items": props.$xAlign
    };
}, function(props) {
    return props.$yAlign && {
        "justify-content": props.$yAlign
    };
}, function(props) {
    return props.$spacing === "none" && none;
}, function(props) {
    return props.$spacing === "x-small" && xsmall;
}, function(props) {
    return props.$spacing === "small" && small3;
}, function(props) {
    return props.$spacing === "regular" && regular3;
}, function(props) {
    return props.$spacing === "large" && large3;
}, function(props) {
    return props.$spacing === "x-large" && xlarge;
}, function(props) {
    return props.$spacing === "x-x-large" && xxlarge;
}, function(props) {
    return props.$spacing === "x-x-x-large" && xxxlarge;
});
// src/components/Stack/Stack.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Stack = function(_param) {
    var _spacing = _param.spacing, spacing = _spacing === void 0 ? "large" : _spacing, xAlign = _param.xAlign, yAlign = _param.yAlign, className = _param.className, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "spacing",
        "xAlign",
        "yAlign",
        "className",
        "children"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StackWrapper, _objectSpreadProps(_objectSpread({
        $spacing: spacing,
        $xAlign: xAlign,
        $yAlign: yAlign,
        className: className
    }, htmlAttrs), {
        children: children
    }));
};
var Stack_default = (0, import_styled_components7.default)(Stack)(_templateObject30());
// src/components/ButtonGroup/styled.ts
var import_styled_components8 = __toESM(require("styled-components"));
var ButtonGroup = import_styled_components8.default.div(_templateObject31());
var styled_default = {
    ButtonGroup: ButtonGroup
};
// src/components/Alert/styled.ts
var danger = import_styled_components9.css(_templateObject32(), Icon_default);
var warning = import_styled_components9.css(_templateObject33(), Icon_default);
var info = import_styled_components9.css(_templateObject34(), Icon_default);
var success = import_styled_components9.css(_templateObject35(), Icon_default);
var small4 = import_styled_components9.css(_templateObject36());
var large4 = import_styled_components9.css(_templateObject37());
var CloseButton = import_styled_components9.default.button(_templateObject38());
var Action = (0, import_styled_components9.default)(ButtonGroup)(_templateObject39());
var Message = (0, import_styled_components9.default)(Stack_default).attrs({
    spacing: "small"
})(_templateObject40());
var Title2 = (0, import_styled_components9.default)(Text_default).attrs({
    weight: "bold"
})(_templateObject41());
var Content = import_styled_components9.default.div(_templateObject42(), function(param) {
    var $size = param.$size;
    return $size === "small" ? small4 : large4;
});
var AlertRoot = import_styled_components9.default.div(_templateObject43(), function(param) {
    var $size = param.$size;
    return $size === "small" ? {
        "max-width": "744px"
    } : {
        "max-width": "1280px"
    };
}, Icon_default, function(props) {
    return props.$variant === "danger" && danger;
}, function(props) {
    return props.$variant === "warning" && warning;
}, function(props) {
    return props.$variant === "info" && info;
}, function(props) {
    return props.$variant === "success" && success;
});
// src/components/Alert/Alert.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var alertIcon = {
    danger: import_faHexagonExclamation.faHexagonExclamation,
    warning: import_faTriangleExclamation.faTriangleExclamation,
    info: import_faCircleInfo.faCircleInfo,
    success: import_faCircleCheck.faCircleCheck,
    default: import_faCircleInfo.faCircleInfo
};
var Alert = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, onDismiss = _param.onDismiss, _size = _param.size, size = _size === void 0 ? "large" : _size, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "variant",
        "onDismiss",
        "size",
        "children"
    ]);
    var alertRole = [
        "danger",
        "warning"
    ].includes(variant) ? "alert" : void 0;
    var ariaLive = [
        "info",
        "default",
        "success"
    ].includes(variant) ? "polite" : void 0;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AlertRoot, _objectSpreadProps(_objectSpread({
        $variant: variant,
        role: alertRole,
        "aria-live": ariaLive,
        $size: size
    }, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                size: "regular",
                icon: alertIcon[variant]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Content, {
                $size: size,
                children: children
            }),
            onDismiss && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CloseButton, {
                onClick: onDismiss,
                "aria-label": "Close",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                    size: "regular",
                    icon: import_faXmark.faXmark
                })
            })
        ]
    }));
};
Alert.Root = (0, import_styled_components10.default)(Alert)(_templateObject44());
Alert.Message = Message;
Alert.Title = Title2;
Alert.Description = Text_default;
Alert.Action = Action;
Alert.displayName = "Alert";
var Alert_default = Alert;
// src/components/Badge/Badge.tsx
var import_styled_components12 = __toESM(require("styled-components"));
// src/components/Badge/styled.ts
var import_styled_components11 = __toESM(require("styled-components"));
var Label = (0, import_styled_components11.default)(Text_default)(_templateObject45());
var Badge = import_styled_components11.default.span(_templateObject47(), function(param) {
    var $badgeColor = param.$badgeColor;
    return import_styled_components11.css(_templateObject46(), $badgeColor, $badgeColor);
}, Label);
var styled_default2 = {
    Badge: Badge,
    Label: Label
};
// src/components/Badge/Badge.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var COLOR_PROPS = {
    default: {
        badgeColor: "color-neutral-100",
        iconColor: "color-neutral-700"
    },
    active: {
        badgeColor: "color-green-100",
        iconColor: "color-green-600"
    },
    info: {
        badgeColor: "color-blue-100",
        iconColor: "color-blue-600"
    },
    attention: {
        badgeColor: "color-yellow-100",
        iconColor: "color-yellow-600"
    },
    critical: {
        badgeColor: "color-pink-100",
        iconColor: "color-pink-600"
    },
    featured: {
        badgeColor: "color-blurple-100",
        iconColor: "color-blurple-600"
    }
};
var Badge2 = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, icon = _param.icon, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "variant",
        "icon",
        "children"
    ]);
    var _variant1 = COLOR_PROPS[variant], badgeColor = _variant1.badgeColor, iconColor = _variant1.iconColor;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(styled_default2.Badge, _objectSpreadProps(_objectSpread({
        $badgeColor: badgeColor
    }, htmlAttrs), {
        children: [
            icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                size: "small",
                colorToken: iconColor,
                icon: icon
            }),
            children && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default2.Label, {
                colorToken: "color-neutral-800",
                size: "small",
                weight: "bold",
                letterSpacing: "regular",
                children: children
            })
        ]
    }));
};
Badge2.displayName = "Badge";
var Badge_default = (0, import_styled_components12.default)(Badge2)(_templateObject48());
// src/components/Button/Button.tsx
var import_react3 = require("react");
var import_styled_components15 = __toESM(require("styled-components"));
// src/hooks/use-telemetry.ts
var import_react = require("react");
var getTelemetry = function(displayName, telemetry, isFirstRenderRef) {
    var start = -1;
    var end = -1;
    var setStart = function() {
        if (telemetry === null || telemetry === void 0 ? void 0 : telemetry.enabled) {
            start = performance.now();
            if (!telemetry.performance[displayName]) {
                telemetry.performance[displayName] = {
                    instances: 0,
                    renders: 0,
                    msTotal: 0,
                    msMin: Number.MAX_SAFE_INTEGER,
                    msMax: 0
                };
            }
        }
    };
    var setEnd = function() {
        if ((telemetry === null || telemetry === void 0 ? void 0 : telemetry.enabled) && start !== -1) {
            end = performance.now();
            var duration = end - start;
            telemetry.performance[displayName].instances += Number(isFirstRenderRef.current);
            telemetry.performance[displayName].renders++;
            telemetry.performance[displayName].msTotal += duration;
            telemetry.performance[displayName].msMin = Math.min(duration, telemetry.performance[displayName].msMin);
            telemetry.performance[displayName].msMax = Math.max(duration, telemetry.performance[displayName].msMax);
            isFirstRenderRef.current = false;
        }
    };
    return {
        setStart: setStart,
        setEnd: setEnd
    };
};
var useTelemetry = function(displayName, context) {
    var isFirstRenderRef = (0, import_react.useRef)(true);
    return getTelemetry(displayName, context, isFirstRenderRef);
};
// src/contexts/telemetry-context.tsx
var import_react2 = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var noop = function() {
    return void 0;
};
var TelemetryContext = import_react2.default.createContext({
    enabled: false,
    performance: {},
    reset: noop
});
var useTelemetryContext = function() {
    var context = (0, import_react2.useContext)(TelemetryContext);
    if (process.env.NODE_ENV === "development" && context === void 0) {
        console.warn("TelemetryContext could not be found.");
        return {
            performance: {}
        };
    }
    return context;
};
// src/components/Button/LoadingIcon.tsx
var import_styled_components13 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var StyledSVG = import_styled_components13.default.svg(_templateObject49());
var LoadingIcon = function() {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledSVG, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", {
                children: "Loading"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11",
                stroke: "#99A6BF",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
                d: "M12 1C14.5193 1 16.8573 1.80549 18.7879 3.18182",
                stroke: "#FFFFFF",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
};
// src/components/Button/styled.ts
var import_styled_components14 = __toESM(require("styled-components"));
var LoadingWrapper = import_styled_components14.default.div(_templateObject50());
var iconOnly = import_styled_components14.css(_templateObject51(), Icon_default);
var primary = import_styled_components14.css(_templateObject52());
var secondary = import_styled_components14.css(_templateObject53());
var tertiary = import_styled_components14.css(_templateObject54());
var destructive = import_styled_components14.css(_templateObject55());
var fluid = import_styled_components14.css(_templateObject56());
var loading = import_styled_components14.css(_templateObject57());
var Button = import_styled_components14.default.button(_templateObject58(), function(props) {
    return props.$variant === "primary" && primary;
}, function(props) {
    return props.$variant === "secondary" && secondary;
}, function(props) {
    return props.$variant === "tertiary" && tertiary;
}, function(props) {
    return props.$variant === "destructive" && destructive;
}, function(props) {
    return props.$loading && loading;
}, function(props) {
    return props.$loading && loading;
}, function(props) {
    return props.$iconOnly && iconOnly;
}, function(props) {
    return props.$fluid && fluid;
});
var styled_default3 = {
    Button: Button,
    LoadingWrapper: LoadingWrapper
};
// src/components/Button/Button.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Button2 = (0, import_react3.forwardRef)(function(_param, ref) {
    var _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, tmp = _param.iconOnly, iconOnly2 = tmp === void 0 ? false : tmp, tmp1 = _param.fluid, fluid2 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.loading, loading3 = tmp2 === void 0 ? false : tmp2, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "variant",
        "iconOnly",
        "fluid",
        "loading",
        "children"
    ]);
    var context = useTelemetryContext();
    var _$ref = useTelemetry("Button", context), setStart = _$ref.setStart, setEnd = _$ref.setEnd;
    setStart();
    var element = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(styled_default3.Button, _objectSpreadProps(_objectSpread({
        ref: ref,
        $variant: variant,
        $iconOnly: iconOnly2,
        $fluid: fluid2,
        $loading: loading3
    }, htmlAttrs), {
        children: [
            loading3 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default3.LoadingWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIcon, {})
            }),
            children
        ]
    }));
    setEnd();
    return element;
});
Button2.displayName = "Button";
var Button_default = (0, import_styled_components15.default)(Button2)(_templateObject59());
// src/components/ButtonGroup/ButtonGroup.tsx
var import_styled_components16 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var ButtonGroup2 = function(htmlAttrs) {
    var context = useTelemetryContext();
    var ref = useTelemetry("ButtonGroup", context), setStart = ref.setStart, setEnd = ref.setEnd;
    setStart();
    var element = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default.ButtonGroup, _objectSpread({}, htmlAttrs));
    setEnd();
    return element;
};
ButtonGroup2.displayName = "ButtonGroup";
var ButtonGroup_default = (0, import_styled_components16.default)(ButtonGroup2)(_templateObject60());
// src/components/DatePicker/DatePicker.tsx
var import_react8 = require("react");
var import_styled_components23 = __toESM(require("styled-components"));
var import_react_day_picker5 = require("react-day-picker");
var import_react9 = require("@floating-ui/react");
var import_date_fns3 = require("date-fns");
// src/components/Portal/Portal.tsx
var import_react_dom = require("react-dom");
var import_styled_components17 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Portal = function(param) {
    var children = param.children, _container = param.container, container = _container === void 0 ? document.body : _container;
    return (0, import_react_dom.createPortal)(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_styled_components17.StyleSheetManager, {
        target: container,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: children
        })
    }), container);
};
Portal.displayName = "Portal";
var Portal_default = (0, import_styled_components17.default)(Portal)(_templateObject61());
// src/components/Input/Input.tsx
var import_react4 = require("react");
var import_styled_components19 = __toESM(require("styled-components"));
// src/components/Input/styled.ts
var import_styled_components18 = __toESM(require("styled-components"));
var ExtensionText = import_styled_components18.css(_templateObject62());
var InputText = import_styled_components18.default.input(_templateObject63());
var Suffix = import_styled_components18.default.span(_templateObject64(), ExtensionText);
var Prefix = import_styled_components18.default.span(_templateObject65(), ExtensionText);
var disabled = import_styled_components18.css(_templateObject66(), InputText, Suffix, Prefix);
var error = import_styled_components18.css(_templateObject67());
var readOnly = import_styled_components18.css(_templateObject68());
var Action2 = import_styled_components18.default.button(_templateObject69());
var ContextualIcon = (0, import_styled_components18.default)(Icon_default)(_templateObject70());
var small5 = import_styled_components18.css(_templateObject71(), InputText, Suffix, Prefix, ContextualIcon);
var Wrapper = import_styled_components18.default.div(_templateObject72(), function(param) {
    var $error = param.$error;
    return $error && error;
}, function(param) {
    var $readOnly = param.$readOnly;
    return $readOnly && readOnly;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled && disabled;
}, function(param) {
    var $size = param.$size;
    return $size === "small" && small5;
});
var ActionWrapper = import_styled_components18.default.div(_templateObject73());
// src/components/Input/Input.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Input = (0, import_react4.forwardRef)(function(_param, ref) {
    var icon = _param.icon, action = _param.action, prefix = _param.prefix, suffix = _param.suffix, className = _param.className, _size = _param.size, size = _size === void 0 ? "regular" : _size, tmp = _param.error, error4 = tmp === void 0 ? false : tmp, tmp1 = _param.disabled, disabled4 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.readOnly, readOnly3 = tmp2 === void 0 ? false : tmp2, htmlAttrs = _objectWithoutProperties(_param, [
        "icon",
        "action",
        "prefix",
        "suffix",
        "className",
        "size",
        "error",
        "disabled",
        "readOnly"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
        $error: error4,
        $disabled: disabled4,
        $readOnly: readOnly3,
        $size: size,
        className: className,
        children: [
            icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContextualIcon, {
                icon: icon
            }),
            prefix && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Prefix, {
                children: prefix
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(InputText, _objectSpread({
                ref: ref,
                disabled: disabled4,
                readOnly: readOnly3
            }, htmlAttrs)),
            suffix && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Suffix, {
                children: suffix
            }),
            action && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ActionWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Action2, {
                    children: action
                })
            })
        ]
    });
});
var Input_default = (0, import_styled_components19.default)(Input)(_templateObject74());
// src/components/DatePicker/Caption.tsx
var import_react_day_picker = require("react-day-picker");
var import_faAngleLeft = require("@fortawesome/free-solid-svg-icons/faAngleLeft");
var import_faAngleRight = require("@fortawesome/free-solid-svg-icons/faAngleRight");
// src/components/DatePicker/styled.ts
var import_styled_components22 = __toESM(require("styled-components"));
// src/components/Select/Select.tsx
var import_react5 = require("react");
var import_styled_components21 = __toESM(require("styled-components"));
var import_react_select2 = require("@radix-ui/react-select");
// src/components/Select/styled.tsx
var import_styled_components20 = __toESM(require("styled-components"));
var import_faAngleDown = require("@fortawesome/pro-solid-svg-icons/faAngleDown");
var import_faAngleUp = require("@fortawesome/pro-solid-svg-icons/faAngleUp");
var import_faCircleNotch = require("@fortawesome/pro-solid-svg-icons/faCircleNotch");
var import_react_select = require("@radix-ui/react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var SelectIcon = (0, import_styled_components20.default)(import_react_select.SelectIcon)(_templateObject75());
var TriggerIcon = (0, import_styled_components20.default)(Icon_default).attrs({
    icon: import_faAngleDown.faAngleDown
})(_templateObject76());
var LoadingIcon2 = (0, import_styled_components20.default)(Icon_default).attrs({
    icon: import_faCircleNotch.faCircleNotch,
    spin: true
})(_templateObject77());
var ItemTextContent = import_styled_components20.default.div(_templateObject78(), Icon_default, Icon_default);
var Trigger = (0, import_styled_components20.default)(import_react_select.Trigger)(_templateObject79(), function(props) {
    return props.$size === "small" ? "var(--font-size-small)" : "var(--font-size-regular)";
}, function(props) {
    return props.$size === "small" ? "var(--line-height-large)" : "var(--line-height-regular)";
}, function(props) {
    return props.$width === "full-width" && "width: 100%;";
}, function(props) {
    return props.$width === "fit-content" && "width: fit-content;";
}, TriggerIcon, function(props) {
    return props.$size === "small" ? "var(--icon-size-small)" : "var(--icon-size-regular)";
}, function(props) {
    return props.$size === "small" ? "var(--font-size-small)" : "var(--font-size-regular)";
}, TriggerIcon, ItemTextContent, ItemTextContent, Icon_default, function(param) {
    var $error = param.$error;
    return $error && "\n    border-color: var(--border-input-error);\n    outline: var(--border-width-small) solid var(--border-input-error-outline);\n  ";
});
var Content2 = (0, import_styled_components20.default)(import_react_select.Content)(_templateObject80(), function(props) {
    return props.$size === "small" ? "var(--font-size-small)" : "var(--font-size-regular)";
}, function(props) {
    return props.position === "popper" && "\n    width: var(--radix-select-trigger-width);\n    max-height: ".concat(props.height ? "".concat(props.height, "px") : "var(--radix-select-content-available-height)", ";\n  ");
}, ItemTextContent, Icon_default, function(props) {
    return props.$size === "small" ? "var(--icon-size-small)" : "var(--icon-size-regular)";
});
var Viewport = (0, import_styled_components20.default)(import_react_select.Viewport)(_templateObject81());
var ItemWrapper = import_styled_components20.default.div(_templateObject82());
var ItemDescription = import_styled_components20.default.div(_templateObject83());
var Item = (0, import_styled_components20.default)(import_react_select.Item)(_templateObject84(), ItemTextContent, ItemDescription);
var scrollButtonStyles = import_styled_components20.css(_templateObject85());
var ScrollUpButton = (0, import_styled_components20.default)(import_react_select.ScrollUpButton).attrs({
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
        icon: import_faAngleUp.faAngleUp
    })
})(_templateObject86(), scrollButtonStyles);
var ScrollDownButton = (0, import_styled_components20.default)(import_react_select.ScrollDownButton).attrs({
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
        icon: import_faAngleDown.faAngleDown
    })
})(_templateObject87(), scrollButtonStyles);
// src/components/Select/Select.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Select = (0, import_react5.forwardRef)(function(_param, forwardedRef) /* @__PURE__ */ {
    var _ariaLabel = _param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "" : _ariaLabel, _ariaLabelledBy = _param.ariaLabelledBy, ariaLabelledBy = _ariaLabelledBy === void 0 ? "" : _ariaLabelledBy, children = _param.children, className = _param.className, tmp = _param.disabled, disabled4 = tmp === void 0 ? false : tmp, tmp1 = _param.error, error4 = tmp1 === void 0 ? false : tmp1, id = _param.id, _container = _param.container, container = _container === void 0 ? document.body : _container, placeholder = _param.placeholder, _size = _param.size, size = _size === void 0 ? "regular" : _size, _showLoadingIndicator = _param.showLoadingIndicator, showLoadingIndicator = _showLoadingIndicator === void 0 ? false : _showLoadingIndicator, _width = _param.width, width = _width === void 0 ? "fit-content" : _width, _position = _param.position, position = _position === void 0 ? "popper" : _position, height = _param.height, htmlAttrs = _objectWithoutProperties(_param, [
        "ariaLabel",
        "ariaLabelledBy",
        "children",
        "className",
        "disabled",
        "error",
        "id",
        "container",
        "placeholder",
        "size",
        "showLoadingIndicator",
        "width",
        "position",
        "height"
    ]);
    return (0, import_jsx_runtime.jsxs)(import_react_select2.Root, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Trigger, {
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                className: className,
                disabled: disabled4,
                id: id,
                $error: error4,
                $size: size,
                $width: width,
                ref: forwardedRef,
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select2.Value, {
                        placeholder: placeholder
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectIcon, {
                        children: showLoadingIndicator ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingIcon2, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TriggerIcon, {})
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select2.Portal, {
                container: container,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Content2, {
                    $size: size,
                    position: position,
                    sideOffset: 4,
                    height: height,
                    children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScrollUpButton, {}),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Viewport, {
                            children: children
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScrollDownButton, {})
                    ]
                })
            })
        ]
    }));
});
Select.displayName = "Select";
var Select_default = (0, import_styled_components21.default)(Select)(_templateObject88());
// src/components/Select/SelectOption.tsx
var import_react6 = require("react");
var import_react_select3 = require("@radix-ui/react-select");
var import_jsx_runtime = require("react/jsx-runtime");
var SelectOption = (0, import_react6.forwardRef)(function(param, forwardedRef) {
    var icon = param.icon, label = param.label, _hoverText = param.hoverText, hoverText = _hoverText === void 0 ? "" : _hoverText, _description = param.description, description = _description === void 0 ? "" : _description, tmp = param.disabled, disabled4 = tmp === void 0 ? false : tmp, value = param.value, leftDecorator = param.leftDecorator;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Item, {
        value: value,
        ref: forwardedRef,
        disabled: disabled4,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ItemWrapper, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_select3.ItemText, {
                    title: hoverText,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ItemTextContent, {
                        children: [
                            leftDecorator,
                            icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                icon: icon
                            }),
                            label
                        ]
                    })
                }),
                description && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ItemDescription, {
                    children: description
                })
            ]
        })
    }, value);
});
SelectOption.displayName = "SelectOption";
var SelectOption_default = SelectOption;
// src/components/DatePicker/styled.ts
var Wrapper2 = import_styled_components22.default.div(_templateObject89());
var CaptionRoot = import_styled_components22.default.div(_templateObject90());
var DayButton = import_styled_components22.default.button(_templateObject91(), function(props) {
    return props.today && "\n    font-weight: bold;\n  ";
}, function(props) {
    return props.outside && "\n    color: var(--foreground-tertiary);\n  ";
}, function(props) {
    return props.selected && "\n    background: var(--border-boolean-active);\n    color: var(--foreground-button-primary-hover);\n\n    :hover {\n      background: var(--border-boolean-active);\n      color: var(--foreground-button-primary-hover);\n    }\n  ";
});
var Dot = import_styled_components22.default.div(_templateObject92(), function(props) {
    return props.selected ? "var(--foreground-button-primary-hover)" : "var(--border-boolean-active)";
});
var StyledMonthsSelect = (0, import_styled_components22.default)(Select_default)(_templateObject93());
var StyledYearsSelect = (0, import_styled_components22.default)(Select_default)(_templateObject94());
// src/components/DatePicker/Caption.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function createCaption(MonthsSelect2, YearsSelect2) {
    return function Caption() {
        var ref = (0, import_react_day_picker.useNavigation)(), goToMonth = ref.goToMonth, nextMonth = ref.nextMonth, previousMonth = ref.previousMonth;
        var ref1 = (0, import_react_day_picker.useDayPicker)(), fromDate = ref1.fromDate, toDate = ref1.toDate;
        if (!fromDate || !toDate) return null;
        return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(CaptionRoot, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                    disabled: !previousMonth,
                    onClick: function() {
                        return previousMonth && goToMonth(previousMonth);
                    },
                    iconOnly: true,
                    variant: "tertiary",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                        icon: import_faAngleLeft.faAngleLeft
                    })
                }),
                MonthsSelect2,
                YearsSelect2,
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                    disabled: !nextMonth,
                    onClick: function() {
                        return nextMonth && goToMonth(nextMonth);
                    },
                    iconOnly: true,
                    variant: "tertiary",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                        icon: import_faAngleRight.faAngleRight
                    })
                })
            ]
        });
    };
}
var Caption_default = createCaption;
// src/components/DatePicker/Day.tsx
var import_react7 = require("react");
var import_react_day_picker2 = require("react-day-picker");
var import_jsx_runtime = require("react/jsx-runtime");
function Day(param) {
    var date = param.date, displayMonth = param.displayMonth;
    var ref, ref1, ref2, ref3, ref4;
    var buttonRef = (0, import_react7.useRef)(null);
    var dayRender = (0, import_react_day_picker2.useDayRender)(date, displayMonth, buttonRef);
    var ref5, ref6, ref7, ref8;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(DayButton, _objectSpreadProps(_objectSpread({
        type: "button",
        name: "day",
        outside: (ref5 = (ref = dayRender.activeModifiers) === null || ref === void 0 ? void 0 : ref.outside) !== null && ref5 !== void 0 ? ref5 : false,
        selected: (ref6 = (ref1 = dayRender.activeModifiers) === null || ref1 === void 0 ? void 0 : ref1.selected) !== null && ref6 !== void 0 ? ref6 : false,
        today: (ref7 = (ref2 = dayRender.activeModifiers) === null || ref2 === void 0 ? void 0 : ref2.today) !== null && ref7 !== void 0 ? ref7 : false,
        ref: buttonRef
    }, dayRender.buttonProps), {
        children: [
            dayRender.buttonProps.children,
            ((ref3 = dayRender.activeModifiers) === null || ref3 === void 0 ? void 0 : ref3.today) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Dot, {
                selected: (ref8 = (ref4 = dayRender.activeModifiers) === null || ref4 === void 0 ? void 0 : ref4.selected) !== null && ref8 !== void 0 ? ref8 : false
            })
        ]
    }));
}
var Day_default = Day;
// src/components/DatePicker/YearsSelect.tsx
var import_react_day_picker3 = require("react-day-picker");
var import_date_fns = require("date-fns");
var import_jsx_runtime = require("react/jsx-runtime");
var createYearsArray = function(fromDate, toDate) {
    var years = [];
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++){
        years.push((0, import_date_fns.setYear)((0, import_date_fns.startOfYear)(new Date()), year));
    }
    return years;
};
function YearsSelect() {
    var ref = (0, import_react_day_picker3.useDayPicker)(), fromDate = ref.fromDate, toDate = ref.toDate;
    var ref1 = (0, import_react_day_picker3.useNavigation)(), displayMonths = ref1.displayMonths, goToMonth = ref1.goToMonth;
    if (!fromDate || !toDate) return null;
    var dropdownYears = createYearsArray(fromDate, toDate);
    var handleChange = function(value) {
        var newMonth = (0, import_date_fns.setYear)((0, import_date_fns.startOfMonth)(displayMonths[0]), Number(value));
        goToMonth(newMonth);
    };
    var defaultYear = displayMonths[0].getFullYear().toString();
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledYearsSelect, {
        onValueChange: handleChange,
        defaultValue: defaultYear,
        children: dropdownYears.map(function(year) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectOption_default, {
                value: year.getFullYear().toString(),
                label: year.getFullYear().toString()
            }, year.getFullYear());
        })
    });
}
// src/components/DatePicker/MonthsSelect.tsx
var import_date_fns2 = require("date-fns");
var import_react_day_picker4 = require("react-day-picker");
var import_jsx_runtime = require("react/jsx-runtime");
var createMonthsArray = function(fromDate, toDate) {
    var dropdownMonths = [];
    if ((0, import_date_fns2.isSameYear)(fromDate, toDate)) {
        var date = (0, import_date_fns2.startOfMonth)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++){
            dropdownMonths.push((0, import_date_fns2.setMonth)(date, month));
        }
    } else {
        var date1 = (0, import_date_fns2.startOfMonth)(new Date());
        for(var month1 = 0; month1 <= 11; month1++){
            dropdownMonths.push((0, import_date_fns2.setMonth)(date1, month1));
        }
    }
    return dropdownMonths;
};
function MonthsSelect(param) {
    var forwardedRef = param.forwardedRef;
    var ref = (0, import_react_day_picker4.useDayPicker)(), fromDate = ref.fromDate, toDate = ref.toDate, locale = ref.locale;
    var ref1 = (0, import_react_day_picker4.useNavigation)(), displayMonths = ref1.displayMonths, goToMonth = ref1.goToMonth;
    if (!fromDate || !toDate) return null;
    var dropdownMonths = createMonthsArray(fromDate, toDate);
    var handleChange = function(value) {
        var selectedMonth = Number(value);
        var newMonth = (0, import_date_fns2.setMonth)((0, import_date_fns2.startOfMonth)(displayMonths[0]), selectedMonth);
        goToMonth(newMonth);
    };
    var defaultMonth = displayMonths[0].getMonth().toString();
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMonthsSelect, {
        onValueChange: handleChange,
        value: defaultMonth,
        ref: forwardedRef,
        children: dropdownMonths.map(function(month) {
            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectOption_default, {
                value: month.getMonth().toString(),
                label: (0, import_date_fns2.format)(month, "MMM", {
                    locale: locale
                })
            }, month.getMonth());
        })
    });
}
// src/components/DatePicker/DatePicker.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DATE_FORMAT = "MM/dd/y";
var DatePicker = (0, import_react8.forwardRef)(function(param, __) {
    var locale = param.locale, initialValue = param.initialValue, onChange = param.onChange, fromYear = param.fromYear, toYear = param.toYear, fromMonth = param.fromMonth, toMonth = param.toMonth, fromDay = param.fromDay, toDay = param.toDay, _variant = param.variant, variant = _variant === void 0 ? "single" : _variant, _inputProps = param.inputProps, inputProps = _inputProps === void 0 ? {} : _inputProps;
    var rootRef = (0, import_react8.useRef)(null);
    var ref = _slicedToArray((0, import_react8.useState)(initialValue), 2), value = ref[0], setValue = ref[1];
    var ref1 = _slicedToArray((0, import_react8.useState)(false), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0, import_react9.useFloating)({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: "bottom-start",
        middleware: [
            (0, import_react9.offset)(20),
            (0, import_react9.shift)(),
            (0, import_react9.flip)()
        ],
        whileElementsMounted: import_react9.autoUpdate
    }), refs = ref2.refs, floatingStyles = ref2.floatingStyles, context = ref2.context;
    var monthsRef = (0, import_react8.useRef)(null);
    var dismiss = (0, import_react9.useDismiss)(context);
    var ref3 = (0, import_react9.useInteractions)([
        dismiss
    ]), getReferenceProps = ref3.getReferenceProps, getFloatingProps = ref3.getFloatingProps;
    var Caption = Caption_default(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(MonthsSelect, {
        forwardedRef: monthsRef
    }), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(YearsSelect, {}));
    var handleChange = function(_, selectedDay) {
        setValue(selectedDay);
        setIsOpen(false);
        onChange(selectedDay);
        if (refs.reference.current) {
            refs.reference.current.value = (0, import_date_fns3.format)(selectedDay, DATE_FORMAT);
        }
    };
    if (variant === "range") {
        return null;
    }
    var disabledDays = [];
    if (fromDay) {
        disabledDays.push({
            before: fromDay
        });
    }
    if (toDay) {
        disabledDays.push({
            after: toDay
        });
    }
    var formattedValue = value ? (0, import_date_fns3.format)(value, DATE_FORMAT) : "";
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
        ref: rootRef,
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Input_default, _objectSpread({
                type: "text",
                size: "regular",
                value: formattedValue,
                onChange: function() {},
                ref: refs.setReference,
                onClick: function() {
                    return setIsOpen(true);
                },
                name: "datepicker",
                placeholder: "MM/DD/YYYY",
                maxLength: 0
            }, inputProps, getReferenceProps())),
            isOpen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Portal_default, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Wrapper2, _objectSpreadProps(_objectSpread({
                    style: floatingStyles,
                    ref: refs.setFloating
                }, getFloatingProps()), {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_day_picker5.DayPicker, {
                        showOutsideDays: true,
                        initialFocus: true,
                        mode: "single",
                        selected: value,
                        defaultMonth: value,
                        onSelect: handleChange,
                        captionLayout: "dropdown-buttons",
                        fromYear: fromYear,
                        toYear: toYear,
                        fromMonth: fromMonth,
                        toMonth: toMonth,
                        fromDate: fromDay,
                        toDate: toDay,
                        disabled: disabledDays,
                        components: {
                            Caption: Caption,
                            Day: Day_default
                        },
                        locale: locale
                    })
                }))
            })
        ]
    });
});
DatePicker.displayName = "DatePicker";
var DatePicker_default = (0, import_styled_components23.default)(DatePicker)(_templateObject95());
// src/components/DropdownMenu/index.ts
var DropdownMenu_exports = {};
__export(DropdownMenu_exports, {
    Arrow: function() {
        return Arrow;
    },
    Content: function() {
        return Content3;
    },
    Description: function() {
        return Description;
    },
    Item: function() {
        return Item2;
    },
    ItemLabel: function() {
        return ItemLabel;
    },
    Label: function() {
        return Label2;
    },
    Portal: function() {
        return Portal3;
    },
    RightSlot: function() {
        return RightSlot;
    },
    Root: function() {
        return Root2;
    },
    Separator: function() {
        return Separator;
    },
    Sub: function() {
        return Sub;
    },
    SubContent: function() {
        return SubContent;
    },
    SubTrigger: function() {
        return SubTrigger;
    },
    Trigger: function() {
        return Trigger2;
    }
});
// src/components/DropdownMenu/DropdownMenu.tsx
var import_react_dropdown_menu = require("@radix-ui/react-dropdown-menu");
var import_styled_components24 = __toESM(require("styled-components"));
var content = import_styled_components24.css(_templateObject96());
var item = import_styled_components24.css(_templateObject97(), Icon_default, Icon_default);
var Root2 = (0, import_styled_components24.default)(import_react_dropdown_menu.Root).attrs(function(props) {
    return _objectSpread({
        modal: false
    }, props);
})(_templateObject98());
var Trigger2 = (0, import_styled_components24.default)(import_react_dropdown_menu.Trigger)(_templateObject99());
var Portal3 = (0, import_styled_components24.default)(import_react_dropdown_menu.Portal)(_templateObject100());
var Content3 = (0, import_styled_components24.default)(import_react_dropdown_menu.Content).attrs({
    sideOffset: 4
})(_templateObject101(), content);
var Item2 = (0, import_styled_components24.default)(import_react_dropdown_menu.Item)(_templateObject102(), item);
var Sub = (0, import_styled_components24.default)(import_react_dropdown_menu.Sub)(_templateObject103());
var Separator = (0, import_styled_components24.default)(import_react_dropdown_menu.Separator)(_templateObject104());
var Label2 = (0, import_styled_components24.default)(import_react_dropdown_menu.Label)(_templateObject105());
var Arrow = (0, import_styled_components24.default)(import_react_dropdown_menu.Arrow)(_templateObject106());
var SubTrigger = (0, import_styled_components24.default)(import_react_dropdown_menu.SubTrigger)(_templateObject107(), item);
var SubContent = (0, import_styled_components24.default)(import_react_dropdown_menu.SubContent).attrs({
    sideOffset: 4
})(_templateObject108(), content);
var RightSlot = import_styled_components24.default.div(_templateObject109());
var ItemLabel = import_styled_components24.default.div(_templateObject110());
var Description = import_styled_components24.default.div(_templateObject111());
// src/components/FloatingPanel/FloatingPanel.tsx
var import_react10 = __toESM(require("react"));
// src/components/FloatingPanel/Buttons.tsx
var import_styled_components25 = __toESM(require("styled-components"));
var import_faXmark2 = require("@fortawesome/pro-solid-svg-icons/faXmark");
var import_faArrowLeft = require("@fortawesome/pro-solid-svg-icons/faArrowLeft");
var import_faUpDownLeftRight = require("@fortawesome/pro-solid-svg-icons/faUpDownLeftRight");
var import_jsx_runtime = require("react/jsx-runtime");
var ActionButton = (0, import_styled_components25.default)(Button_default).attrs({
    variant: "tertiary",
    iconOnly: true
})(_templateObject112());
var BackButton = (0, import_styled_components25.default)(ActionButton).attrs({
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
        icon: import_faArrowLeft.faArrowLeft
    })
})(_templateObject113());
var CloseButton2 = (0, import_styled_components25.default)(ActionButton).attrs({
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
        icon: import_faXmark2.faXmark
    })
})(_templateObject114(), Icon_default);
var DragButton = (0, import_styled_components25.default)(ActionButton).attrs({
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
        icon: import_faUpDownLeftRight.faUpDownLeftRight
    })
})(_templateObject115(), function(param) {
    var dragging = param.dragging;
    return dragging ? "grabbing" : "grab";
});
// src/components/FloatingPanel/styled.ts
var import_styled_components26 = __toESM(require("styled-components"));
var theme = "\n  --header-background: var(--color-neutral-50);\n  --header-foreground: var(--color-neutral-900);\n  --header-divider: var(--color-neutral-200);\n\n  --content-background: var(--color-neutral-0);\n\n  [data-theme='dark'] & {\n    --header-background: var(--color-neutral-950);\n    --header-foreground: var(--color-neutral-50);\n    --header-divider: var(--color-neutral-700);\n\n    --content-background: var(--color-neutral-500);\n  }\n";
var FloatingPanelContainer = import_styled_components26.default.div(_templateObject116(), theme);
var HeaderContainer = import_styled_components26.default.div(_templateObject118(), function(param) {
    var isDraggable = param.isDraggable;
    return isDraggable && import_styled_components26.css(_templateObject117());
}, Title_default, Icon_default);
var HeaderBackAndTitle = import_styled_components26.default.div(_templateObject119());
var HeaderActions = import_styled_components26.default.div(_templateObject120());
var Content4 = import_styled_components26.default.div(_templateObject122(), function(param) {
    var _top = param.top, top = _top === void 0 ? 0 : _top, _innerOffset = param.innerOffset, innerOffset = _innerOffset === void 0 ? 0 : _innerOffset;
    return import_styled_components26.css(_templateObject121(), innerOffset, top);
});
// src/components/FloatingPanel/FloatingPanel.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Root3 = import_react10.default.forwardRef(function(_param, ref) {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FloatingPanelContainer, _objectSpreadProps(_objectSpread({
        ref: ref,
        role: "dialog"
    }, htmlAttrs), {
        children: children
    }));
});
var Header = function(param) {
    var title = param.title, onBack = param.onBack, showBack = param.showBack, onDismiss = param.onDismiss, dragHandlers = param.dragHandlers, _isHeaderDraggable = param.isHeaderDraggable, isHeaderDraggable = _isHeaderDraggable === void 0 ? false : _isHeaderDraggable;
    var headerProps = isHeaderDraggable ? dragHandlers : {};
    var buttonProps = isHeaderDraggable ? {} : dragHandlers;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(HeaderContainer, _objectSpreadProps(_objectSpread({}, headerProps), {
        isDraggable: isHeaderDraggable,
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(HeaderBackAndTitle, {
                children: [
                    showBack && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BackButton, {
                        onClick: onBack,
                        "aria-label": "Return to previous panel"
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Title_default, {
                        children: title
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(HeaderActions, {
                children: [
                    dragHandlers && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DragButton, _objectSpreadProps(_objectSpread({}, buttonProps), {
                        "aria-label": "Drag to move"
                    })),
                    onDismiss && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CloseButton2, {
                        onClick: onDismiss,
                        "aria-label": "Close"
                    })
                ]
            })
        ]
    }));
};
var Body = function(param) {
    var innerOffset = param.innerOffset, top = param.top, children = param.children;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Content4, {
        innerOffset: innerOffset,
        top: top,
        children: children
    });
};
var FloatingPanel_default = {
    Root: Root3,
    Header: Header,
    Body: Body
};
// src/components/Form/FormContext.ts
var import_react11 = require("react");
var initialContextValue = {
    size: "regular"
};
var FormContext = (0, import_react11.createContext)(initialContextValue);
var FormProvider = FormContext.Provider;
var useFormContext = function() {
    return (0, import_react11.useContext)(FormContext) || initialContextValue;
};
// src/components/Form/styled.ts
var import_styled_components27 = __toESM(require("styled-components"));
var Form = import_styled_components27.default.form(_templateObject123());
var styled_default4 = {
    Form: Form
};
// src/components/Form/Form.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Form2 = function(_param) {
    var children = _param.children, _size = _param.size, size = _size === void 0 ? "regular" : _size, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "size"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FormProvider, {
        value: {
            size: size
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default4.Form, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
            children: children
        }))
    });
};
Form2.displayName = "Form";
var Form_default = Form2;
// src/components/FormField/styled.ts
var import_styled_components32 = __toESM(require("styled-components"));
// src/components/InlineMessage/InlineMessage.tsx
var import_styled_components29 = __toESM(require("styled-components"));
var import_faCircleExclamation = require("@fortawesome/free-solid-svg-icons/faCircleExclamation");
// src/components/InlineMessage/styled.ts
var import_styled_components28 = __toESM(require("styled-components"));
var Wrapper3 = (0, import_styled_components28.default)(Text_default).attrs({
    forwardedAs: "p"
})(_templateObject124(), function(props) {
    return props.$variant === "helper" && "color: var(--foreground-secondary);";
}, function(props) {
    return props.$variant === "error" && "color: var(--foreground-inline-error);";
});
var PrefixIcon = (0, import_styled_components28.default)(Icon_default)(_templateObject125(), function(props) {
    return props.$variant === "error" && "color: var(--foreground-inline-error);";
});
// src/components/InlineMessage/InlineMessage.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var InlineMessage = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "helper" : _variant, icon = _param.icon, children = _param.children, className = _param.className, htmlAttrs = _objectWithoutProperties(_param, [
        "variant",
        "icon",
        "children",
        "className"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper3, _objectSpreadProps(_objectSpread({
        $variant: variant,
        className: className
    }, htmlAttrs), {
        children: [
            (icon !== null && icon !== void 0 ? icon : variant === "error") && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PrefixIcon, {
                icon: icon !== null && icon !== void 0 ? icon : import_faCircleExclamation.faCircleExclamation
            }),
            children
        ]
    }));
};
var InlineMessage_default = (0, import_styled_components29.default)(InlineMessage)(_templateObject126());
// src/components/Label/Label.tsx
var import_styled_components31 = __toESM(require("styled-components"));
// src/components/Label/styled.tsx
var import_styled_components30 = __toESM(require("styled-components"));
var Wrapper4 = import_styled_components30.default.label(_templateObject127());
var LabelText = (0, import_styled_components30.default)(Text_default)(_templateObject128());
var Optional = (0, import_styled_components30.default)(Text_default)(_templateObject129());
var Interaction = import_styled_components30.default.span(_templateObject130());
// src/components/Label/Label.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Label3 = function(_param) {
    var children = _param.children, interaction = _param.interaction, _optional = _param.optional, optional = _optional === void 0 ? false : _optional, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "interaction",
        "optional"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper4, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LabelText, {
                weight: "bold",
                children: children
            }),
            optional && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Optional, {
                children: "(optional)"
            }),
            interaction && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Interaction, {
                children: interaction
            })
        ]
    }));
};
Label3.displayName = "Label";
var Label_default = (0, import_styled_components31.default)(Label3)(_templateObject131());
// src/components/FormField/styled.ts
var small6 = import_styled_components32.css(_templateObject132(), InlineMessage_default, Label_default);
var inline = import_styled_components32.css(_templateObject133());
var FormField = import_styled_components32.default.div(_templateObject134(), InlineMessage_default, Label_default, function(param) {
    var $size = param.$size;
    return $size === "small" && small6;
}, function(param) {
    var $inline = param.$inline;
    return $inline && inline;
});
var styled_default5 = {
    FormField: FormField
};
// src/components/FormField/FormField.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FormField2 = function(_param) {
    var children = _param.children, size = _param.size, inline2 = _param.inline, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "size",
        "inline"
    ]);
    var ref = useFormContext(), contextSize = ref.size;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(styled_default5.FormField, _objectSpreadProps(_objectSpread({
        $inline: Boolean(inline2),
        $size: size || contextSize
    }, htmlAttrs), {
        children: children
    }));
};
FormField2.displayName = "FormField";
var FormField_default = FormField2;
// src/components/Link/Link.tsx
var import_styled_components34 = __toESM(require("styled-components"));
// src/components/Link/styled.tsx
var import_styled_components33 = __toESM(require("styled-components"));
var PrimitiveLink = import_styled_components33.default.a(_templateObject135(), function(param) {
    var $colorToken = param.$colorToken;
    return "var(--".concat($colorToken, ")");
}, function(param) {
    var $icon = param.$icon, $inline = param.$inline;
    return $icon && ($inline ? "var(--spacing-x-small)" : "var(--spacing-small)");
}, function(param) {
    var $activeColorToken = param.$activeColorToken;
    return "var(--".concat($activeColorToken, ")");
});
var IconWrapper = import_styled_components33.default.span(_templateObject136());
// src/components/Link/Link.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Link = function(_param) {
    var children = _param.children, icon = _param.icon, tmp = _param.inline, inline2 = tmp === void 0 ? false : tmp, _size = _param.size, size = _size === void 0 ? "regular" : _size, _colorToken = _param.colorToken, colorToken = _colorToken === void 0 ? "foreground-link" : _colorToken, _activeColorToken = _param.activeColorToken, activeColorToken = _activeColorToken === void 0 ? "foreground-link-active" : _activeColorToken, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "icon",
        "inline",
        "size",
        "colorToken",
        "activeColorToken"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(PrimitiveLink, _objectSpreadProps(_objectSpread({
        rel: icon ? "noopener noreferrer" : void 0,
        target: icon ? "_blank" : void 0,
        $icon: icon,
        $inline: inline2,
        $colorToken: colorToken,
        $activeColorToken: activeColorToken
    }, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, {
                forwardedAs: "span",
                weight: "bold",
                size: size,
                colorToken: colorToken,
                children: children
            }),
            icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                    size: size,
                    icon: icon
                })
            })
        ]
    }));
};
Link.displayName = "Link";
var Link_default = (0, import_styled_components34.default)(Link)(_templateObject137());
// src/components/Modal/Modal.tsx
var import_react_dialog2 = require("@radix-ui/react-dialog");
// src/components/Modal/styled.ts
var import_react_dialog = require("@radix-ui/react-dialog");
var import_styled_components35 = __toESM(require("styled-components"));
var Overlay = import_styled_components35.default.div(_templateObject138());
var Actions = import_styled_components35.default.div(_templateObject139());
var small7 = import_styled_components35.css(_templateObject140(), Actions);
var Content5 = (0, import_styled_components35.default)(import_react_dialog.Content)(_templateObject141(), DEFAULT_TEXT_COLOR_TOKEN, regularTextProps, Actions, function(param) {
    var $size = param.$size;
    return $size === "small" && small7;
});
var Title3 = (0, import_styled_components35.default)(import_react_dialog.Title)(_templateObject142(), SubTitleStyles);
var Close = (0, import_styled_components35.default)(import_react_dialog.Close)(_templateObject143(), DEFAULT_TEXT_COLOR_TOKEN);
// src/components/Modal/Modal.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Modal = function(_param) {
    var children = _param.children, trigger = _param.trigger, _size = _param.size, size = _size === void 0 ? "regular" : _size, _modal = _param.modal, modal = _modal === void 0 ? true : _modal, open = _param.open, onOpenChange = _param.onOpenChange, onOpenAutoFocus = _param.onOpenAutoFocus, _container = _param.container, container = _container === void 0 ? document.body : _container, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "trigger",
        "size",
        "modal",
        "open",
        "onOpenChange",
        "onOpenAutoFocus",
        "container"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_dialog2.Root, _objectSpreadProps(_objectSpread({
        modal: modal,
        open: open,
        onOpenChange: onOpenChange
    }, htmlAttrs), {
        children: [
            trigger && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_dialog2.Trigger, {
                asChild: true,
                children: trigger
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_dialog2.Portal, {
                container: container,
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Overlay, {}),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Content5, {
                        $size: size,
                        onOpenAutoFocus: onOpenAutoFocus,
                        children: children
                    })
                ]
            })
        ]
    }));
};
Modal.displayName = "Modal";
var Modal_default = {
    Root: Modal,
    Title: Title3,
    Description: import_react_dialog2.Description,
    Close: Close,
    Actions: Actions
};
// src/components/Pagination/Pagination.tsx
var import_react12 = require("react");
var import_styled_components39 = __toESM(require("styled-components"));
var import_faAngleLeft2 = require("@fortawesome/pro-solid-svg-icons/faAngleLeft");
var import_faAngleRight2 = require("@fortawesome/pro-solid-svg-icons/faAngleRight");
var import_faAnglesLeft = require("@fortawesome/pro-solid-svg-icons/faAnglesLeft");
var import_faAnglesRight = require("@fortawesome/pro-solid-svg-icons/faAnglesRight");
// src/components/Row/Row.tsx
var import_styled_components37 = __toESM(require("styled-components"));
// src/components/Row/styled.ts
var import_styled_components36 = __toESM(require("styled-components"));
var none2 = import_styled_components36.css(_templateObject144());
var xsmall2 = import_styled_components36.css(_templateObject145());
var small8 = import_styled_components36.css(_templateObject146());
var regular4 = import_styled_components36.css(_templateObject147());
var large5 = import_styled_components36.css(_templateObject148());
var xlarge2 = import_styled_components36.css(_templateObject149());
var xxlarge2 = import_styled_components36.css(_templateObject150());
var xxxlarge2 = import_styled_components36.css(_templateObject151());
var RowWrapper = import_styled_components36.default.div(_templateObject152(), function(props) {
    return props.$xAlign && {
        "justify-content": props.$xAlign
    };
}, function(props) {
    return props.$yAlign && {
        "align-items": props.$yAlign
    };
}, function(props) {
    return props.$wrap && "flex-wrap: wrap;";
}, function(props) {
    return props.$spacing === "none" && none2;
}, function(props) {
    return props.$spacing === "x-small" && xsmall2;
}, function(props) {
    return props.$spacing === "small" && small8;
}, function(props) {
    return props.$spacing === "regular" && regular4;
}, function(props) {
    return props.$spacing === "large" && large5;
}, function(props) {
    return props.$spacing === "x-large" && xlarge2;
}, function(props) {
    return props.$spacing === "x-x-large" && xxlarge2;
}, function(props) {
    return props.$spacing === "x-x-x-large" && xxxlarge2;
});
// src/components/Row/Row.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Row = function(param) {
    var _spacing = param.spacing, spacing = _spacing === void 0 ? "large" : _spacing, _wrap = param.wrap, wrap = _wrap === void 0 ? false : _wrap, xAlign = param.xAlign, yAlign = param.yAlign, className = param.className, children = param.children;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RowWrapper, {
        $spacing: spacing,
        $wrap: wrap,
        $xAlign: xAlign,
        $yAlign: yAlign,
        className: className,
        children: children
    });
};
var Row_default = (0, import_styled_components37.default)(Row)(_templateObject153());
// src/components/Pagination/styled.ts
var import_styled_components38 = __toESM(require("styled-components"));
var PaginationContainer = import_styled_components38.default.nav(_templateObject154());
var SectionContainer = (0, import_styled_components38.default)(Row_default)(_templateObject155());
var PageInput = (0, import_styled_components38.default)(Input_default)(_templateObject156());
var PageSizeSelect = (0, import_styled_components38.default)(Select_default)(_templateObject157());
var TextNoWrap = (0, import_styled_components38.default)(Text_default)(_templateObject158());
// src/components/Pagination/Pagination.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var isNumber = function(value) {
    return typeof value === "number";
};
var getPageSizeOptions = function(totalResults) {
    var defaultOptions = [
        "10",
        "25",
        "50",
        "100"
    ];
    var filteredOptions = defaultOptions.filter(function(x) {
        return Number.parseInt(x, 10) < totalResults;
    });
    if (totalResults < 100) {
        filteredOptions.push("All");
    }
    return filteredOptions;
};
var Pagination = function(_param) {
    var totalResults = _param.totalResults, pageIndex = _param.pageIndex, pageSize = _param.pageSize, setPagination = _param.setPagination, htmlAttrs = _objectWithoutProperties(_param, [
        "totalResults",
        "pageIndex",
        "pageSize",
        "setPagination"
    ]);
    var pageCount = totalResults ? Math.ceil(totalResults / pageSize) : 1;
    var hasNextPage = pageIndex < pageCount - 1;
    var hasPreviousPage = pageIndex > 0;
    var visibleResultsRange = "".concat(pageIndex * pageSize + 1, "-").concat(Math.min(totalResults, (pageIndex + 1) * pageSize));
    var setPageSize = function(newPageSize) {
        return setPagination(function(prev) {
            var topRowIndex = prev.pageSize * prev.pageIndex;
            var newPageIndex = Math.floor(topRowIndex / newPageSize);
            return _objectSpreadProps(_objectSpread({}, prev), {
                pageIndex: newPageIndex,
                pageSize: newPageSize
            });
        });
    };
    var setPageIndex = function(newPageIndex) {
        return setPagination(function(prev) {
            return _objectSpreadProps(_objectSpread({}, prev), {
                pageIndex: newPageIndex
            });
        });
    };
    var fetchNextPage = function() {
        return setPagination(function(prev) {
            return _objectSpreadProps(_objectSpread({}, prev), {
                pageIndex: prev.pageIndex + 1
            });
        });
    };
    var fetchPreviousPage = function() {
        return setPagination(function(prev) {
            return _objectSpreadProps(_objectSpread({}, prev), {
                pageIndex: prev.pageIndex - 1
            });
        });
    };
    var updatePageSize = function(value) {
        if (value === "All") {
            setPageSize(totalResults);
        }
        var number = Number.parseInt(value, 10);
        if (!Number.isNaN(number)) {
            setPageSize(number);
        }
    };
    var ref = _slicedToArray((0, import_react12.useState)(pageIndex + 1), 2), inputValue = ref[0], setInputValue = ref[1];
    var isInvalidInputValue = function(value) {
        return value > pageCount || value < 1;
    };
    var updateInputValue = function(event) {
        if (!event) return;
        var value = Number.parseInt(event.target.value, 10);
        setInputValue(Number.isNaN(value) ? "" : value);
    };
    var submitInputValue = function() {
        if (!isNumber(inputValue) || isInvalidInputValue(inputValue)) {
            return;
        }
        setPageIndex(inputValue - 1);
    };
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            submitInputValue();
        }
    };
    (0, import_react12.useEffect)(function() {
        setInputValue(pageIndex + 1);
    }, [
        pageIndex
    ]);
    if (totalResults <= 10) {
        return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(PaginationContainer, _objectSpreadProps(_objectSpread({
        "aria-label": "Table page navigation"
    }, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SectionContainer, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Text_default, {
                        colorToken: "foreground-primary",
                        children: [
                            visibleResultsRange,
                            " of ",
                            totalResults,
                            " results"
                        ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PageSizeSelect, {
                        "aria-label": "Select page size",
                        value: totalResults <= pageSize ? "All" : pageSize.toString(),
                        onValueChange: updatePageSize,
                        children: getPageSizeOptions(totalResults).map(function(option) {
                            return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectOption_default, {
                                label: option === "All" ? option : "".concat(option, " / page"),
                                value: option
                            }, option);
                        })
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SectionContainer, {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Row_default, {
                        spacing: "regular",
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                                "aria-label": "Go to first page",
                                variant: "secondary",
                                iconOnly: true,
                                disabled: !hasPreviousPage,
                                onClick: function() {
                                    return setPageIndex(0);
                                },
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                    icon: import_faAnglesLeft.faAnglesLeft,
                                    colorToken: "foreground-link"
                                })
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                                "aria-label": "Go to previous page",
                                variant: "secondary",
                                iconOnly: true,
                                disabled: !hasPreviousPage,
                                onClick: fetchPreviousPage,
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                    icon: import_faAngleLeft2.faAngleLeft,
                                    colorToken: "foreground-link"
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Row_default, {
                        spacing: "small",
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Text_default, {
                                colorToken: "foreground-primary",
                                weight: "bold",
                                children: "Page"
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PageInput, {
                                size: "small",
                                type: "number",
                                "aria-label": "Page number input",
                                min: 1,
                                max: pageCount,
                                value: inputValue,
                                onChange: updateInputValue,
                                onBlur: submitInputValue,
                                onKeyDown: handleKeyDown,
                                "aria-invalid": isInvalidInputValue(inputValue) ? "true" : "false",
                                error: isInvalidInputValue(inputValue)
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TextNoWrap, {
                                colorToken: "foreground-primary",
                                weight: "bold",
                                children: [
                                    "of ",
                                    pageCount
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Row_default, {
                        spacing: "regular",
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                                "aria-label": "Go to next page",
                                variant: "secondary",
                                iconOnly: true,
                                disabled: !hasNextPage,
                                onClick: fetchNextPage,
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                    icon: import_faAngleRight2.faAngleRight,
                                    colorToken: "foreground-link"
                                })
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Button_default, {
                                "aria-label": "Go to last page",
                                variant: "secondary",
                                iconOnly: true,
                                disabled: !hasNextPage,
                                onClick: function() {
                                    return setPageIndex(pageCount - 1);
                                },
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                    icon: import_faAnglesRight.faAnglesRight,
                                    colorToken: "foreground-link"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var Pagination_default = (0, import_styled_components39.default)(Pagination)(_templateObject159());
// src/components/Pagination/use-pagination.ts
var import_react13 = require("react");
var usePagination = function() {
    var ref = _slicedToArray((0, import_react13.useState)({
        pageIndex: 0,
        pageLabel: "First page",
        pageSize: 10
    }), 2), ref1 = ref[0], pageIndex = ref1.pageIndex, pageSize = ref1.pageSize, setPagination = ref[1];
    var deriveAriaLabel = function(totalResults) {
        var pageCount = totalResults ? Math.ceil(totalResults / pageSize) : 1;
        if (pageIndex === 0) {
            return "First page";
        }
        if (pageIndex + 1 < pageCount) {
            return "Page ".concat(pageIndex + 1);
        }
        return "Last page, page ".concat(pageIndex + 1);
    };
    return {
        pageIndex: pageIndex,
        pageSize: pageSize,
        setPagination: setPagination,
        deriveAriaLabel: deriveAriaLabel
    };
};
// src/components/Popover/Popover.tsx
var import_react_popover2 = require("@radix-ui/react-popover");
var import_styled_components41 = __toESM(require("styled-components"));
// src/components/Popover/styled.tsx
var import_styled_components40 = __toESM(require("styled-components"));
var import_react_popover = require("@radix-ui/react-popover");
var Content6 = (0, import_styled_components40.default)(import_react_popover.Content)(_templateObject160());
var Arrow2 = (0, import_styled_components40.default)(import_react_popover.Arrow)(_templateObject161());
var Close2 = (0, import_styled_components40.default)(import_react_popover.Close).attrs({
    "aria-label": "Close"
})(_templateObject162());
var Title4 = (0, import_styled_components40.default)(Text_default).attrs({
    size: "medium",
    weight: "semibold",
    colorToken: "foreground-primary"
})(_templateObject163());
var Description3 = (0, import_styled_components40.default)(Text_default).attrs({
    size: "regular",
    colorToken: "foreground-secondary"
})(_templateObject164());
var Action3 = import_styled_components40.default.div(_templateObject165());
// src/components/Popover/Close.tsx
var import_react14 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var Close3 = (0, import_react14.forwardRef)(function(param, forwardedRef) {
    var onDismiss = param.onDismiss, children = param.children;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Close2, {
        ref: forwardedRef,
        onClick: onDismiss,
        children: children
    });
});
var Close_default = Close3;
// src/components/Popover/Popover.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Popover = function(_param) {
    var open = _param.open, trigger = _param.trigger, disabled4 = _param.disabled, children = _param.children, onOpenChange = _param.onOpenChange, onOpenAutoFocus = _param.onOpenAutoFocus, _caret = _param.caret, caret = _caret === void 0 ? true : _caret, _align = _param.align, align = _align === void 0 ? "center" : _align, _placement = _param.placement, placement = _placement === void 0 ? "top" : _placement, _container = _param.container, container = _container === void 0 ? document.body : _container, htmlAttrs = _objectWithoutProperties(_param, [
        "open",
        "trigger",
        "disabled",
        "children",
        "onOpenChange",
        "onOpenAutoFocus",
        "caret",
        "align",
        "placement",
        "container"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_popover2.Root, _objectSpreadProps(_objectSpread({
        open: open,
        onOpenChange: onOpenChange
    }, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_popover2.Trigger, {
                asChild: true,
                disabled: disabled4,
                children: trigger
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_popover2.Portal, {
                container: container,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Content6, {
                    sideOffset: 4,
                    side: placement,
                    align: align,
                    onOpenAutoFocus: onOpenAutoFocus,
                    children: [
                        children,
                        caret && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arrow2, {
                            width: 16,
                            height: 8
                        })
                    ]
                })
            })
        ]
    }));
};
Popover.Root = (0, import_styled_components41.default)(Popover)(_templateObject166());
Popover.Title = Title4;
Popover.Description = Description3;
Popover.Action = Action3;
Popover.Close = Close_default;
Popover.displayName = "Popover";
var Popover_default = Popover;
// src/components/Progress/Progress.tsx
var import_styled_components43 = __toESM(require("styled-components"));
// src/components/Progress/styled.tsx
var import_react_progress = require("@radix-ui/react-progress");
var import_styled_components42 = __toESM(require("styled-components"));
var ProgressBar = (0, import_styled_components42.default)(import_react_progress.Indicator)(_templateObject167(), function(param) {
    var $variant = param.$variant;
    switch($variant){
        case "success":
            return "var(--color-green-600)";
        case "error":
            return "var(--color-pink-600)";
        default:
            return "var(--color-blurple-600)";
    }
});
var Bar = (0, import_styled_components42.default)(import_react_progress.Root)(_templateObject168(), ProgressBar);
// src/components/Progress/Progress.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Progress = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _max = _param.max, max = _max === void 0 ? 100 : _max, _value = _param.value, value = _value === void 0 ? 0 : _value, htmlAttrs = _objectWithoutProperties(_param, [
        "variant",
        "max",
        "value"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Bar, _objectSpreadProps(_objectSpread({
        max: max,
        value: value,
        "aria-label": "Progress bar"
    }, htmlAttrs), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ProgressBar, {
            $variant: variant,
            style: {
                width: "".concat(value, "%")
            }
        })
    }));
};
Progress.displayName = "Progress";
var Progress_default = (0, import_styled_components43.default)(Progress)(_templateObject169());
// src/components/Radio/Item.tsx
var import_styled_components45 = __toESM(require("styled-components"));
// src/components/Radio/styled.tsx
var import_styled_components44 = __toESM(require("styled-components"));
var import_react_radio_group = require("@radix-ui/react-radio-group");
var StyledItem = (0, import_styled_components44.default)(import_react_radio_group.Item)(_templateObject170());
var StyledIndicator = (0, import_styled_components44.default)(import_react_radio_group.Indicator)(_templateObject171());
var ItemRoot = import_styled_components44.default.div(_templateObject172());
var StyledGroup = (0, import_styled_components44.default)(import_react_radio_group.Root)(_templateObject173(), StyledItem);
var StyledLabel = import_styled_components44.default.label(_templateObject174());
var DescriptionText = (0, import_styled_components44.default)(Text_default)(_templateObject175());
// src/components/Radio/Item.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Item4 = function(_param) {
    var id = _param.id, label = _param.label, description = _param.description, htmlAttrs = _objectWithoutProperties(_param, [
        "id",
        "label",
        "description"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabel, {
        htmlFor: id,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ItemRoot, {
            tabIndex: 0,
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Row_default, {
                    yAlign: "center",
                    spacing: "small",
                    children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledItem, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
                            id: id,
                            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIndicator, {})
                        })),
                        label
                    ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Row_default, {
                    yAlign: "center",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DescriptionText, {
                        size: "small",
                        children: description
                    })
                })
            ]
        })
    });
};
Item4.displayName = "RadioItem";
var Item_default = (0, import_styled_components45.default)(Item4)(_templateObject176());
// src/components/Radio/Group.tsx
var Group = StyledGroup;
Group.displayName = "RadioGroup";
var Group_default = Group;
// src/components/Radio/Radio.tsx
var Radio_default = {
    Item: Item_default,
    Group: Group_default
};
// src/components/Section/Section.tsx
var import_styled_components46 = __toESM(require("styled-components"));
var Section = import_styled_components46.default.div(_templateObject177());
Section.displayName = "Section";
var Section_default = Section;
// src/components/Slider/Slider.tsx
var import_styled_components48 = __toESM(require("styled-components"));
// src/components/Slider/styled.ts
var import_styled_components47 = __toESM(require("styled-components"));
var import_react_slider = require("@radix-ui/react-slider");
var SliderTrack = (0, import_styled_components47.default)(import_react_slider.Track)(_templateObject178());
var SliderThumb = (0, import_styled_components47.default)(import_react_slider.Thumb)(_templateObject179());
var small9 = import_styled_components47.css(_templateObject180(), SliderTrack, SliderThumb);
var SliderRoot = (0, import_styled_components47.default)(import_react_slider.Root)(_templateObject181(), function(param) {
    var size = param.size;
    return size === "small" && small9;
});
var SliderRange = (0, import_styled_components47.default)(import_react_slider.Range)(_templateObject182());
// src/components/Slider/Slider.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Slider = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "small" : _size, htmlAttrs = _objectWithoutProperties(_param, [
        "size"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SliderRoot, _objectSpreadProps(_objectSpread({
        size: size
    }, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SliderTrack, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SliderRange, {})
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SliderThumb, {
                "aria-label": "Slider thumb"
            })
        ]
    }));
};
Slider.displayName = "Slider";
var Slider_default = (0, import_styled_components48.default)(Slider)(_templateObject183());
// src/components/Spinner/Spinner.tsx
var import_react15 = require("react");
// src/components/Spinner/styled.ts
var import_styled_components50 = __toESM(require("styled-components"));
// src/components/Spinner/Logo.jsx
var import_styled_components49 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Logo_default = import_styled_components49.default.svg.attrs({
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 107.4",
    style: {
        enableBackground: "new 0 0 86 107.4"
    },
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
                        className: "st0",
                        d: "M37.7,58.6l30.1,47.1c0.8,1.1,1.9,1.7,3.3,1.7h11.1c2.1,0,3.8-1.7,3.8-3.8V3.8c0-3.6-4.5-5.2-6.9-2.4\n				L37.7,54C36.8,55.2,36.8,57.2,37.7,58.6z"
                    })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
                        className: "st0",
                        d: "M3.9,107.3h19.8c2.1,0,3.8-1.7,3.8-3.8V78.2c0-3.6-4.5-5.2-6.9-2.4L0.8,101.1\n				C-1.1,103.8,0.8,107.3,3.9,107.3z"
                    })
                })
            ]
        })
    })
})(_templateObject184());
// src/components/Spinner/styled.ts
var pulse = import_styled_components50.keyframes(_templateObject185());
var merge = import_styled_components50.keyframes(_templateObject186());
var spinner = import_styled_components50.keyframes(_templateObject187());
var move = function($position) {
    return import_styled_components50.keyframes(_templateObject188(), $position, $position);
};
var grow = function($position) {
    return import_styled_components50.keyframes(_templateObject189(), $position === "top" ? "border-bottom-color: var(--color-blurple-600);" : "border-top-color: var(--color-blurple-600);", $position, $position === "top" ? "border-bottom-color: var(--color-blurple-600);" : "border-top-color: var(--color-blurple-600);\n          ");
};
var Wrapper5 = import_styled_components50.default.div(_templateObject190());
var Rotate = import_styled_components50.default.div(_templateObject191(), pulse, spinner);
var Arc = import_styled_components50.default.div(_templateObject193(), function(param) {
    var $position = param.$position;
    return import_styled_components50.css(_templateObject192(), move($position), grow($position), merge, $position);
});
var IconWrapper2 = import_styled_components50.default.div(_templateObject194(), pulse);
var Icon2 = (0, import_styled_components50.default)(Logo_default)(_templateObject195());
// src/components/Spinner/Spinner.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Spinner = function() {
    var ref = _slicedToArray((0, import_react15.useState)(0), 2), value = ref[0], setValue = ref[1];
    var rotateRef = (0, import_react15.useRef)(null);
    var topRef = (0, import_react15.useRef)(null);
    var bottomRef = (0, import_react15.useRef)(null);
    (0, import_react15.useEffect)(function() {
        var toggle = function() {
            return setValue(function(val) {
                return val > 0 ? 0 : 1;
            });
        };
        var timer = setInterval(toggle, 3600);
        return function() {
            clearInterval(timer);
        };
    }, [
        value
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper5, {
        role: "progressbar",
        "aria-label": "Loading",
        "aria-busy": true,
        "aria-live": "polite",
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Rotate, {
                ref: rotateRef,
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arc, {
                        $position: "top",
                        ref: topRef
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arc, {
                        $position: "bottom",
                        ref: bottomRef
                    })
                ]
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconWrapper2, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon2, {})
            })
        ]
    }, value);
};
Spinner.displayName = "Spinner";
var Spinner_default = Spinner;
// src/components/Table/Table.tsx
var import_styled_components52 = __toESM(require("styled-components"));
// src/components/Table/styled.ts
var import_styled_components51 = __toESM(require("styled-components"));
var Root8 = import_styled_components51.default.table(_templateObject196());
var Thead = import_styled_components51.default.thead(_templateObject197());
var Td = import_styled_components51.default.td(_templateObject198(), function(param) {
    var xAlign = param.xAlign;
    return xAlign && {
        "text-align": xAlign
    };
}, function(param) {
    var yAlign = param.yAlign;
    return yAlign && {
        "vertical-align": yAlign
    };
}, function(param) {
    var $spacing = param.$spacing;
    return $spacing && {
        padding: "var(--spacing-".concat($spacing, ") var(--spacing-regular);")
    };
});
var Th = import_styled_components51.default.th(_templateObject199(), function(param) {
    var yAlign = param.yAlign;
    return yAlign && {
        "vertical-align": yAlign
    };
}, function(param) {
    var $sortable = param.$sortable;
    return $sortable && "\n      cursor: pointer;\n  \n      &:hover {\n        background: var(--color-neutral-50);\n      }\n      ";
}, function(param) {
    var $sortable = param.$sortable, $sortDirection = param.$sortDirection;
    return $sortable && $sortDirection && "\n      border-bottom: var(--border-width-small) solid var(--border-table-active);\n      }\n    ";
});
var ThContent = import_styled_components51.default.span(_templateObject200(), function(param) {
    var xAlign = param.xAlign;
    return xAlign && {
        "justify-content": xAlign
    };
});
var ThWrapper = (0, import_styled_components51.default)(Row_default).attrs({
    spacing: "small",
    xAlign: "space-between",
    yAlign: "center"
})(_templateObject201());
// src/components/Table/Root.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Root9 = function(_param) /* @__PURE__ */ {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Root8, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Thead.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Thead2 = function(_param) /* @__PURE__ */ {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Thead, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Tbody.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Tbody = function(_param) /* @__PURE__ */ {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)("tbody", _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Tfoot.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Tfoot = function(_param) /* @__PURE__ */ {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)("tfoot", _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Tr.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Tr = function(_param) /* @__PURE__ */ {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)("tr", _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Td.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Td2 = function(_param) /* @__PURE__ */ {
    var _xAlign = _param.xAlign, xAlign = _xAlign === void 0 ? "left" : _xAlign, _yAlign = _param.yAlign, yAlign = _yAlign === void 0 ? "middle" : _yAlign, _spacing = _param.spacing, spacing = _spacing === void 0 ? "regular" : _spacing, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "xAlign",
        "yAlign",
        "spacing",
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Td, _objectSpreadProps(_objectSpread({
        xAlign: xAlign,
        yAlign: yAlign,
        $spacing: spacing
    }, htmlAttrs), {
        children: children
    }));
};
// src/components/Table/Th.tsx
var import_faArrowDown = require("@fortawesome/free-solid-svg-icons/faArrowDown");
var import_faArrowUp = require("@fortawesome/free-solid-svg-icons/faArrowUp");
var import_jsx_runtime = require("react/jsx-runtime");
var SORTED_ICONS = {
    ASC: import_faArrowUp.faArrowUp,
    DESC: import_faArrowDown.faArrowDown
};
var SORT_DIRECTION = {
    ASC: "ascending",
    DESC: "descending"
};
var Th2 = function(_param) {
    var _xAlign = _param.xAlign, xAlign = _xAlign === void 0 ? "left" : _xAlign, _yAlign = _param.yAlign, yAlign = _yAlign === void 0 ? "middle" : _yAlign, children = _param.children, _sortable = _param.sortable, sortable = _sortable === void 0 ? false : _sortable, sortDirection = _param.sortDirection, htmlAttrs = _objectWithoutProperties(_param, [
        "xAlign",
        "yAlign",
        "children",
        "sortable",
        "sortDirection"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Th, _objectSpreadProps(_objectSpread({
        $sortable: sortable,
        $sortDirection: sortDirection,
        yAlign: yAlign,
        "aria-sort": sortDirection ? SORT_DIRECTION[sortDirection] : "none"
    }, htmlAttrs), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ThWrapper, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThContent, {
                    xAlign: xAlign,
                    children: children
                }),
                sortDirection && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon, {
                    size: "small",
                    icon: SORTED_ICONS[sortDirection]
                })
            ]
        })
    }));
};
// src/components/Table/Table.tsx
var Table_default = {
    Root: (0, import_styled_components52.default)(Root9)(_templateObject202()),
    Thead: (0, import_styled_components52.default)(Thead2)(_templateObject203()),
    Tbody: (0, import_styled_components52.default)(Tbody)(_templateObject204()),
    Tfoot: (0, import_styled_components52.default)(Tfoot)(_templateObject205()),
    Tr: (0, import_styled_components52.default)(Tr)(_templateObject206()),
    Td: (0, import_styled_components52.default)(Td2)(_templateObject207()),
    Th: (0, import_styled_components52.default)(Th2)(_templateObject208())
};
// src/components/Table/use-sort-table.ts
var import_react16 = require("react");
var useSortTable = function(defaultSortDirection, defaultSortKey, sortDirectionOptions) {
    var ref = _slicedToArray((0, import_react16.useState)({
        sortKey: defaultSortKey,
        sortDirection: defaultSortDirection
    }), 2), ref1 = ref[0], sortKey = ref1.sortKey, sortDirection = ref1.sortDirection, setSort = ref[1];
    var getNextSortDirection = function(options) {
        var currentIndex = options.indexOf(sortDirection);
        return options[(currentIndex + 1) % options.length];
    };
    var sortColumn = function(key, preferredSortDirection) {
        if (key === sortKey) {
            var nextSortDirection = getNextSortDirection(sortDirectionOptions);
            setSort({
                sortKey: key,
                sortDirection: nextSortDirection
            });
            return;
        }
        setSort({
            sortKey: key,
            sortDirection: preferredSortDirection !== null && preferredSortDirection !== void 0 ? preferredSortDirection : defaultSortDirection
        });
    };
    var getColumnSortDirection = function(key) {
        return sortKey === key ? sortDirection : void 0;
    };
    return {
        sortKey: sortKey,
        sortDirection: sortDirection,
        sortColumn: sortColumn,
        getColumnSortDirection: getColumnSortDirection,
        getNextSortDirection: getNextSortDirection
    };
};
// src/components/Tabs/List.tsx
var import_react17 = require("react");
var import_styled_components54 = __toESM(require("styled-components"));
// src/components/Tabs/styled.tsx
var import_react_tabs = require("@radix-ui/react-tabs");
var import_styled_components53 = __toESM(require("styled-components"));
var theme2 = "\n    --tabs-hover-background: var(--color-neutral-100);\n    --tabs-active-hover-background: var(--color-blurple-100);\n\n  [data-theme='dark'] & {\n    --tabs-hover-background: var(--color-neutral-700);\n    --tabs-active-hover-background: var(--color-blurple-900);\n  }\n";
var fillContent = import_styled_components53.css(_templateObject209());
var TriggerContent = import_styled_components53.default.div(_templateObject210(), fillContent);
var Trigger5 = (0, import_styled_components53.default)(import_react_tabs.Trigger)(_templateObject212(), function(param) {
    var asChild = param.asChild;
    return asChild && import_styled_components53.css(_templateObject211(), fillContent);
}, Icon_default, TriggerContent);
var SelectedIndicator = import_styled_components53.default.div(_templateObject213());
var List = (0, import_styled_components53.default)(import_react_tabs.List)(_templateObject214());
var small10 = import_styled_components53.css(_templateObject215(), Trigger5, Icon_default);
var center = import_styled_components53.css(_templateObject216(), List);
var stretch = import_styled_components53.css(_templateObject217(), Trigger5);
var Root10 = (0, import_styled_components53.default)(import_react_tabs.Root).attrs({
    activationMode: "manual"
})(_templateObject218(), theme2, function(param) {
    var $size = param.$size;
    return $size === "small" && small10;
}, function(param) {
    var $align = param.$align;
    return $align === "center" && center;
}, function(param) {
    var $align = param.$align;
    return $align === "stretch" && stretch;
});
var Content7 = (0, import_styled_components53.default)(import_react_tabs.Content)(_templateObject219());
// src/components/Tabs/List.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var List2 = function(_param) {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    var $list = (0, import_react17.useRef)(null);
    var ref = _slicedToArray((0, import_react17.useState)({
        width: 0,
        left: 0
    }), 2), dimensions = ref[0], setDimensions = ref[1];
    var calculateDimensions = function() {
        var ref, ref1;
        var selectedElement = (ref = $list.current) === null || ref === void 0 ? void 0 : ref.querySelector("[data-state=active]");
        var parentElement = selectedElement === null || selectedElement === void 0 ? void 0 : (ref1 = selectedElement.parentElement) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect();
        var ref2 = (selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.getBoundingClientRect()) || {
            width: 0,
            left: 0
        }, width = ref2.width, left = ref2.left;
        setDimensions({
            width: width,
            left: left - ((parentElement === null || parentElement === void 0 ? void 0 : parentElement.left) || 0)
        });
    };
    var handleClick = function() {
        calculateDimensions();
    };
    (0, import_react17.useLayoutEffect)(function() {
        calculateDimensions();
        window.addEventListener("resize", calculateDimensions);
        return function() {
            window.removeEventListener("resize", calculateDimensions);
        };
    }, []);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(List, _objectSpreadProps(_objectSpread({
        ref: $list,
        onClick: handleClick
    }, htmlAttrs), {
        children: [
            children,
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectedIndicator, {
                style: dimensions
            })
        ]
    }));
};
var List_default = (0, import_styled_components54.default)(List2)(_templateObject220());
// src/components/Tabs/Trigger.tsx
var import_styled_components55 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Trigger6 = function(_param) /* @__PURE__ */ {
    var icon = _param.icon, value = _param.value, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "icon",
        "value",
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Trigger5, _objectSpreadProps(_objectSpread({
        value: value
    }, htmlAttrs), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TriggerContent, {
            children: [
                icon && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                    icon: icon
                }),
                children
            ]
        })
    }));
};
var Trigger_default = (0, import_styled_components55.default)(Trigger6)(_templateObject221());
// src/components/Tabs/Root.tsx
var import_styled_components56 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Root11 = function(_param) /* @__PURE__ */ {
    var defaultValue = _param.defaultValue, size = _param.size, align = _param.align, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "defaultValue",
        "size",
        "align",
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Root10, _objectSpreadProps(_objectSpread({
        $size: size,
        $align: align,
        defaultValue: defaultValue
    }, htmlAttrs), {
        children: children
    }));
};
var Root_default = (0, import_styled_components56.default)(Root11)(_templateObject222());
// src/components/Tabs/Content.tsx
var import_styled_components57 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Content8 = function(_param) /* @__PURE__ */ {
    var value = _param.value, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "value",
        "children"
    ]);
    return (0, import_jsx_runtime.jsx)(Content7, _objectSpreadProps(_objectSpread({
        value: value
    }, htmlAttrs), {
        children: children
    }));
};
var Content_default = (0, import_styled_components57.default)(Content8)(_templateObject223());
// src/components/Tabs/Tabs.tsx
var Tabs_default = {
    Root: Root_default,
    List: List_default,
    Trigger: Trigger_default,
    Content: Content_default
};
// src/components/TextArea/TextArea.tsx
var import_react18 = require("react");
var import_styled_components59 = __toESM(require("styled-components"));
// src/components/TextArea/styled.ts
var import_styled_components58 = __toESM(require("styled-components"));
var TextAreaInput = import_styled_components58.default.textarea(_templateObject224());
var disabled2 = import_styled_components58.css(_templateObject225(), TextAreaInput);
var error2 = import_styled_components58.css(_templateObject226());
var readOnly2 = import_styled_components58.css(_templateObject227());
var Counter = (0, import_styled_components58.default)(Text_default)(_templateObject228());
var small11 = import_styled_components58.css(_templateObject229(), TextAreaInput, Counter, Counter);
var counter = import_styled_components58.css(_templateObject230(), TextAreaInput);
var Wrapper6 = import_styled_components58.default.div(_templateObject231(), function(param) {
    var $counter = param.$counter;
    return $counter && counter;
}, function(param) {
    var $error = param.$error;
    return $error && error2;
}, function(param) {
    var $readOnly = param.$readOnly;
    return $readOnly && readOnly2;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled && disabled2;
}, function(param) {
    var $size = param.$size;
    return $size === "small" && small11;
});
// src/components/TextArea/TextArea.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TextArea = (0, import_react18.forwardRef)(function(_param, ref) {
    var counter2 = _param.counter, _size = _param.size, size = _size === void 0 ? "regular" : _size, tmp = _param.error, error4 = tmp === void 0 ? false : tmp, tmp1 = _param.disabled, disabled4 = tmp1 === void 0 ? false : tmp1, tmp2 = _param.readOnly, readOnly3 = tmp2 === void 0 ? false : tmp2, className = _param.className, htmlAttrs = _objectWithoutProperties(_param, [
        "counter",
        "size",
        "error",
        "disabled",
        "readOnly",
        "className"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper6, {
        $error: error4,
        $disabled: disabled4,
        $readOnly: readOnly3,
        $size: size,
        $counter: counter2,
        className: className,
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextAreaInput, _objectSpread({
                ref: ref,
                disabled: disabled4,
                readOnly: readOnly3
            }, htmlAttrs)),
            counter2 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Counter, {
                variant: size === "small" ? "200" : "100",
                children: counter2
            })
        ]
    });
});
var TextArea_default = (0, import_styled_components59.default)(TextArea)(_templateObject232());
// src/components/Toast/Toast.tsx
var import_faCheckCircle = require("@fortawesome/pro-solid-svg-icons/faCheckCircle");
var import_faHexagonExclamation2 = require("@fortawesome/pro-solid-svg-icons/faHexagonExclamation");
var import_faTriangleExclamation2 = require("@fortawesome/pro-solid-svg-icons/faTriangleExclamation");
var import_react_hot_toast = __toESM(require("react-hot-toast"));
// src/components/Toast/styled.ts
var import_styled_components60 = __toESM(require("styled-components"));
var Wrapper7 = import_styled_components60.default.div(_templateObject233());
var LoadingSpinner = import_styled_components60.default.img(_templateObject234());
// src/components/Toast/loading.svg
var loading_default = "./loading-XGQEYDCS.svg";
// src/components/Toast/Toast.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var show = function(content2) {
    return (0, import_react_hot_toast.default)(content2);
};
var success2 = function(message) {
    return import_react_hot_toast.default.success(message);
};
var danger2 = function(message) {
    return import_react_hot_toast.default.error(message);
};
var loading2 = function(message) {
    return import_react_hot_toast.default.loading(message);
};
var warning2 = function(message) {
    return (0, import_react_hot_toast.default)(message, {
        style: {
            background: "var(--background-warning)",
            border: "var(--border-width-x-small) solid var(--border-warning)"
        },
        icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
            colorToken: "foreground-warning",
            icon: import_faTriangleExclamation2.faTriangleExclamation,
            size: "regular"
        })
    });
};
var Toaster = function() {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Wrapper7, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_hot_toast.Toaster, {
            position: "bottom-left",
            toastOptions: {
                duration: 6e3,
                style: {
                    background: "var(--background-app)",
                    border: "var(--border-width-x-small) solid var(--border-input-hover)",
                    borderRadius: "var(--border-radius-small)",
                    color: "var(--foreground-primary)",
                    justifyContent: "flex-start",
                    padding: "var(--spacing-small) var(--spacing-regular)",
                    boxShadow: "var(--elevation-300)"
                },
                success: {
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                        colorToken: "foreground-success",
                        icon: import_faCheckCircle.faCheckCircle,
                        size: "regular"
                    }),
                    style: {
                        background: "var(--background-success)",
                        border: "var(--border-width-x-small) solid var(--border-success)"
                    }
                },
                error: {
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                        colorToken: "foreground-error",
                        icon: import_faHexagonExclamation2.faHexagonExclamation,
                        size: "regular"
                    }),
                    style: {
                        background: "var(--background-error)",
                        border: "var(--border-width-x-small) solid var(--border-error)"
                    }
                },
                loading: {
                    icon: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingSpinner, {
                        src: loading_default,
                        alt: "Loading"
                    })
                }
            }
        })
    });
};
var Toast_default = {
    show: show,
    success: success2,
    danger: danger2,
    warning: warning2,
    loading: loading2
};
// src/components/ToggleButton/ToggleButton.tsx
var import_styled_components62 = __toESM(require("styled-components"));
// src/components/ToggleButton/styled.tsx
var import_styled_components61 = __toESM(require("styled-components"));
var import_react_toggle_group = require("@radix-ui/react-toggle-group");
var Label4 = import_styled_components61.default.div(_templateObject235());
var ContentWrapper = import_styled_components61.default.div(_templateObject236(), Icon_default);
var Item5 = (0, import_styled_components61.default)(import_react_toggle_group.Item)(_templateObject237(), Label4, Label4, Label4);
var Root12 = (0, import_styled_components61.default)(import_react_toggle_group.Root)(_templateObject238());
// src/components/ToggleButton/ToggleButton.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ToggleButton = function(_param) {
    var children = _param.children, label = _param.label, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "label"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Item5, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContentWrapper, {
                children: children
            }),
            label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Label4, {
                children: label
            })
        ]
    }));
};
ToggleButton.displayName = "ToggleButton";
var ToggleButton_default = (0, import_styled_components62.default)(ToggleButton)(_templateObject239());
// src/components/ToggleButton/ToggleGroup.tsx
var import_styled_components63 = __toESM(require("styled-components"));
var ToggleGroup = Root12;
ToggleGroup.displayName = "ToggleGroup";
var ToggleGroup_default = (0, import_styled_components63.default)(ToggleGroup)(_templateObject240());
// src/components/Tooltip/Tooltip.tsx
var import_styled_components65 = __toESM(require("styled-components"));
var import_react_tooltip2 = require("@radix-ui/react-tooltip");
// src/components/Tooltip/styled.ts
var import_styled_components64 = __toESM(require("styled-components"));
var import_react_tooltip = require("@radix-ui/react-tooltip");
var theme3 = "\n  --background-tooltip: var(--color-neutral-900);\n  --foreground-tooltip: var(--color-neutral-0);\n  --foreground-tooltip-link: var(--color-blurple-400);\n  --foreground-tooltip-link-active: var(--color-blurple-300);\n  --foreground-link: var(--foreground-tooltip-link);\n\n[data-theme='dark'] & {\n  --background-tooltip: var(--color-neutral-500);\n  --foreground-tooltip: var(--color-neutral-50);\n  --foreground-tooltip-link: var(--color-blurple-300);\n  --foreground-tooltip-link-active: var(--color-blurple-200);\n  --foreground-link-active: var(--foreground-tooltip-link-active);\n }\n ";
var Trigger7 = import_styled_components64.default.div(_templateObject241());
var sizesMap = {
    small: "width: 120px;",
    regular: "width: 200px;",
    large: "width: 320px;"
};
var ContentContainer = (0, import_styled_components64.default)(import_react_tooltip.Content)(_templateObject242());
var Content9 = import_styled_components64.default.div(_templateObject243(), theme3, function(param) {
    var $size = param.$size;
    return $size ? sizesMap[$size] : "white-space: nowrap;";
});
var Arrow3 = (0, import_styled_components64.default)(import_react_tooltip.Arrow)(_templateObject244());
// src/components/Tooltip/Tooltip.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Tooltip = function(_param) {
    var children = _param.children, content2 = _param.content, size = _param.size, defaultOpen = _param.defaultOpen, tmp = _param.disabled, disabled4 = tmp === void 0 ? false : tmp, open = _param.open, onOpenChange = _param.onOpenChange, delayDuration = _param.delayDuration, placement = _param.placement, htmlAttrs = _objectWithoutProperties(_param, [
        "children",
        "content",
        "size",
        "defaultOpen",
        "disabled",
        "open",
        "onOpenChange",
        "delayDuration",
        "placement"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_tooltip2.Provider, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_tooltip2.Root, _objectSpreadProps(_objectSpread({
            defaultOpen: defaultOpen,
            open: disabled4 ? false : open,
            onOpenChange: onOpenChange,
            delayDuration: delayDuration
        }, htmlAttrs), {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_tooltip2.Trigger, {
                    asChild: true,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Trigger7, {
                        children: children
                    })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_tooltip2.Portal, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ContentContainer, {
                        sideOffset: 5,
                        side: placement,
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Content9, {
                                $size: size,
                                children: content2
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Arrow3, {})
                        ]
                    })
                })
            ]
        }))
    });
};
Tooltip.displayName = "Tooltip";
var Tooltip_default = (0, import_styled_components65.default)(Tooltip)(_templateObject245());
// src/components/Checkbox/Checkbox.tsx
var import_free_solid_svg_icons = require("@fortawesome/free-solid-svg-icons");
var import_styled_components67 = __toESM(require("styled-components"));
// src/components/Checkbox/styled.tsx
var import_styled_components66 = __toESM(require("styled-components"));
var import_react_checkbox = require("@radix-ui/react-checkbox");
var CheckboxLabel = (0, import_styled_components66.default)(Text_default).attrs({
    size: "regular"
})(_templateObject246());
var CheckboxDescription = (0, import_styled_components66.default)(Text_default).attrs({
    size: "small"
})(_templateObject247());
var StyledRoot = (0, import_styled_components66.default)(import_react_checkbox.Root)(_templateObject248());
var StyledIndicator2 = (0, import_styled_components66.default)(import_react_checkbox.Indicator)(_templateObject249());
var StyledLabel2 = import_styled_components66.default.label(_templateObject250());
var error3 = import_styled_components66.css(_templateObject251(), StyledLabel2, CheckboxDescription, StyledIndicator2, StyledRoot, StyledLabel2, CheckboxDescription, StyledIndicator2, StyledRoot);
var disabled3 = import_styled_components66.css(_templateObject252(), StyledLabel2, CheckboxDescription, StyledRoot, StyledIndicator2, StyledLabel2, StyledIndicator2, CheckboxDescription, StyledRoot);
var CheckboxWrapper = import_styled_components66.default.div(_templateObject253(), StyledLabel2, StyledIndicator2, CheckboxDescription, StyledRoot, function(param) {
    var $error = param.$error;
    return $error && error3;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled && disabled3;
});
// src/components/Checkbox/Checkbox.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Checkbox = function(_param) /* @__PURE__ */ {
    var id = _param.id, children = _param.children, tmp = _param.error, error4 = tmp === void 0 ? false : tmp, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, tmp1 = _param.disabled, disabled4 = tmp1 === void 0 ? false : tmp1, onCheckedChange = _param.onCheckedChange, htmlAttrs = _objectWithoutProperties(_param, [
        "id",
        "children",
        "error",
        "checked",
        "disabled",
        "onCheckedChange"
    ]);
    return (0, import_jsx_runtime.jsx)(CheckboxWrapper, {
        $error: error4,
        $disabled: disabled4,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabel2, {
            htmlFor: id,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Row_default, {
                yAlign: "flex-start",
                spacing: "small",
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledRoot, _objectSpreadProps(_objectSpread({
                        id: id,
                        disabled: disabled4,
                        checked: checked,
                        onCheckedChange: onCheckedChange,
                        role: "checkbox",
                        "aria-checked": checked
                    }, htmlAttrs), {
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIndicator2, {
                            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                                icon: import_free_solid_svg_icons.faCheck,
                                size: "small",
                                "aria-hidden": "true"
                            })
                        })
                    })),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Stack_default, {
                        spacing: "none",
                        children: children
                    })
                ]
            })
        })
    });
};
Checkbox.displayName = "Checkbox";
Checkbox.Label = CheckboxLabel;
Checkbox.Description = CheckboxDescription;
var Checkbox_default = (0, import_styled_components67.default)(Checkbox)(_templateObject254());
// src/components/Metric/Metric.tsx
var import_react19 = require("react");
var import_faCircleInfo2 = require("@fortawesome/pro-solid-svg-icons/faCircleInfo");
// src/components/Metric/styled.tsx
var import_styled_components68 = __toESM(require("styled-components"));
var nested = import_styled_components68.css(_templateObject255());
var section = import_styled_components68.css(_templateObject256());
var small12 = import_styled_components68.css(_templateObject257());
var Header2 = (0, import_styled_components68.default)(Row_default).attrs({
    spacing: "small",
    yAlign: "center"
})(_templateObject258());
var BodyContainer = (0, import_styled_components68.default)(Row_default).attrs(function() {
    return {
        spacing: "small",
        yAlign: "center"
    };
})(_templateObject259());
var Title5 = (0, import_styled_components68.default)(Text_default).attrs({
    size: "regular",
    weight: "semibold"
})(_templateObject260());
var CurrentValue = (0, import_styled_components68.default)(Text_default).attrs({
    size: "large",
    weight: "bold"
})(_templateObject261());
var HeaderDecorator = import_styled_components68.default.button(_templateObject262());
var Description4 = (0, import_styled_components68.default)(Text_default).attrs({
    size: "small"
})(_templateObject263());
var Container = import_styled_components68.default.div(_templateObject266(), function(param) {
    var $type = param.$type;
    return $type === "nested" && nested;
}, function(param) {
    var $type = param.$type;
    return $type === "section" && section;
}, function(param) {
    var $size = param.$size;
    return $size === "small" && small12;
}, Title5, CurrentValue, Description4, Icon_default, HeaderDecorator, Title5, function(param) {
    var $size = param.$size;
    return $size === "small" && import_styled_components68.css(_templateObject264());
}, CurrentValue, function(param) {
    var $size = param.$size;
    return $size === "small" && import_styled_components68.css(_templateObject265());
});
// src/components/Metric/Metric.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MetricContext = (0, import_react19.createContext)({
    size: "large",
    disabled: false
});
var Metric = (0, import_react19.forwardRef)(function(_param, ref) {
    var _size = _param.size, size = _size === void 0 ? "large" : _size, _type = _param.type, type = _type === void 0 ? "section" : _type, children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "size",
        "type",
        "children"
    ]);
    var isDisabled = htmlAttrs["aria-disabled"] === true;
    var providerValue = (0, import_react19.useMemo)(function() {
        return {
            size: size,
            disabled: isDisabled
        };
    }, [
        isDisabled,
        size
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MetricContext.Provider, {
        value: providerValue,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Container, _objectSpreadProps(_objectSpread({
            $size: size,
            $type: type
        }, htmlAttrs), {
            ref: ref,
            children: children
        }))
    });
});
Metric.displayName = "Metric";
var HeaderInfoButton = function(_param) {
    var children = _param.children, buttonProps = _objectWithoutProperties(_param, [
        "children"
    ]);
    var ref = (0, import_react19.useContext)(MetricContext), disabled4 = ref.disabled;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Tooltip_default, {
        placement: "top",
        content: children,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(HeaderDecorator, _objectSpreadProps(_objectSpread({}, buttonProps), {
            disabled: disabled4,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Icon_default, {
                icon: import_faCircleInfo2.faCircleInfo,
                colorToken: "foreground-button-tertiary-default"
            })
        }))
    });
};
HeaderInfoButton.displayName = "MetricHeaderInfoButton";
var LoadingPlaceholder = function() {
    var size = (0, import_react19.useContext)(MetricContext).size;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", {
        role: "img",
        "aria-labelledby": "loading-aria",
        viewBox: size === "large" ? "0 0 100% 72" : "0 0 100% 60",
        width: "100%",
        height: size === "large" ? "72px" : "60px",
        preserveAspectRatio: "none",
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", {
                id: "loading-aria",
                children: "Loading"
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", {
                x: "0",
                y: "0",
                width: "100%",
                height: "100%",
                clipPath: "url(#clip-path)",
                style: {
                    fill: 'url("#fill")'
                }
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("defs", {
                children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("clipPath", {
                        id: "clip-path",
                        children: size === "large" ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                            children: [
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", {
                                    width: "50%",
                                    height: "44",
                                    rx: "6"
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", {
                                    y: "49",
                                    width: "100%",
                                    height: "24",
                                    rx: "6"
                                })
                            ]
                        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
                            children: [
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", {
                                    width: "50%",
                                    height: "32",
                                    rx: "6"
                                }),
                                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", {
                                    y: "36",
                                    width: "100%",
                                    height: "24",
                                    rx: "6"
                                })
                            ]
                        })
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("linearGradient", {
                        id: "fill",
                        children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", {
                                offset: "0.599964",
                                stopColor: "#DCE4F2",
                                stopOpacity: "1",
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("animate", {
                                    attributeName: "offset",
                                    values: "-2; -2; 1",
                                    keyTimes: "0; 0.25; 1",
                                    dur: "2s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", {
                                offset: "1.59996",
                                stopColor: "rgba(220, 228, 242, 0.00)",
                                stopOpacity: "1",
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("animate", {
                                    attributeName: "offset",
                                    values: "-1; -1; 2",
                                    keyTimes: "0; 0.25; 1",
                                    dur: "2s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", {
                                offset: "2.59996",
                                stopColor: "#DCE4F2",
                                stopOpacity: "1",
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("animate", {
                                    attributeName: "offset",
                                    values: "0; 0; 3",
                                    keyTimes: "0; 0.25; 1",
                                    dur: "2s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
LoadingPlaceholder.displayName = "MetricLoadingPlaceholder";
var Body2 = function(param) {
    var isLoading = param.isLoading, description = param.description, children = param.children;
    if (isLoading) {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LoadingPlaceholder, {});
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BodyContainer, {
                children: children
            }),
            description && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Description4, {
                children: description
            })
        ]
    });
};
var Metric_default = {
    Root: Metric,
    Header: Header2,
    Title: Title5,
    HeaderInfoButton: HeaderInfoButton,
    CurrentValue: CurrentValue,
    Body: Body2,
    LoadingPlaceholder: LoadingPlaceholder
};
// src/components/Metric/MetricGroup.tsx
var import_styled_components69 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Container2 = import_styled_components69.default.div(_templateObject267());
var MetricGroup = function(_param) {
    var children = _param.children, htmlAttrs = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Container2, _objectSpreadProps(_objectSpread({}, htmlAttrs), {
        children: children
    }));
};
MetricGroup.displayName = "MetricGroup";
var MetricGroup_default = (0, import_styled_components69.default)(MetricGroup)(_templateObject268());
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    Alert: Alert,
    Badge: Badge,
    Button: Button,
    ButtonGroup: ButtonGroup,
    Checkbox: Checkbox,
    Code: Code,
    DEFAULT_TEXT_COLOR_TOKEN: DEFAULT_TEXT_COLOR_TOKEN,
    DatePicker: DatePicker,
    DropdownMenu: DropdownMenu,
    FloatingPanel: FloatingPanel,
    Form: Form,
    FormField: FormField,
    Icon: Icon,
    InlineMessage: InlineMessage,
    Input: Input,
    Label: Label,
    Link: Link,
    Metric: Metric,
    Modal: Modal,
    Pagination: Pagination,
    Popover: Popover,
    Portal: Portal,
    PrimitiveText: PrimitiveText,
    Progress: Progress,
    Radio: Radio,
    Row: Row,
    Section: Section,
    Select: Select,
    SelectOption: SelectOption,
    Slider: Slider,
    Spinner: Spinner,
    Stack: Stack,
    SubTitle: SubTitle,
    Table: Table,
    Tabs: Tabs,
    Text: Text,
    TextArea: TextArea,
    Title: Title,
    Toaster: Toaster,
    ToggleButton: ToggleButton,
    ToggleGroup: ToggleGroup,
    Tooltip: Tooltip,
    regularTextProps: regularTextProps,
    toast: toast,
    usePagination: usePagination,
    useSortTable: useSortTable
});
//# sourceMappingURL=index.js.map